"use strict";

/*==============================================================================*
*TRESTLE W007
*YOUR TRESTLE INSIGHT
*DATA
*Version 2.0
*
*SECTION A
*FOUNDATION + SCIENTIFIC REFERENCE LIBRARY
*
*This file contains controlled reference data and approved interpretation rules.
*No DOM manipulation.
*No report rendering.
*No localStorage writes.
*No PDF logic.
*==============================================================================*/


/*==============================================================================*
*ROOT DATA OBJECT
*==============================================================================*/

const TRESTLE_W007_INSIGHT_DATA={


/*==============================================================================*
*VERSION
*==============================================================================*/

version:"1.0",


/*==============================================================================*
*CORE PHILOSOPHY
*==============================================================================*/

principles:{

    evidenceOnly:true,

    noDiagnosis:true,

    noTreatmentAdvice:true,

    noUnsupportedCausation:true,

    missingDataMeansUnknown:true,

    useRecordedDataOnly:true,

    maxScienceReferences:2,

    maxDoctorQuestions:3,

    maxTomorrowFocus:1,

    reportGenerationHour:19,

    archiveLimit:7

},


/*==============================================================================*
*SUPPORTED PROMISES
*==============================================================================*/

promises:[

    "Balanced Life",

    "More Energy",

    "Better Sleep",

    "More Calmness",

    "Better Focus",

    "Healthier Living"

],


/*==============================================================================*
*SUPPORTED LIFE STAGES
*==============================================================================*/

lifeStages:[

    "Reproductive Years",

    "Planning Pregnancy",

    "Pregnant",

    "Postpartum",

    "Perimenopause",

    "Menopause"

],


/*==============================================================================*
*SUPPORTED DIABETES PROFILES
*==============================================================================*/

diabetesProfiles:[

    "Prediabetes",

    "Type 1 Diabetes",

    "Type 2 Diabetes",

    "Gestational Diabetes",

    "Previous Gestational Diabetes",

    "Not Sure"

],


/*==============================================================================*
*EVIDENCE CLASSES
*
*A = Directly recorded fact
*B = Mathematically calculated fact
*C = Approved contextual observation
*X = Prohibited inference
*==============================================================================*/

evidenceClasses:{

    A:{

        label:"Recorded Fact",

        allowed:true

    },


    B:{

        label:"Calculated Fact",

        allowed:true

    },


    C:{

        label:"Approved Context",

        allowed:true

    },


    X:{

        label:"Unsupported Inference",

        allowed:false

    }

},


/*==============================================================================*
*SCIENTIFIC REFERENCE LIBRARY
*
*IMPORTANT:
*
*These references provide GENERAL CONTEXT.
*
*They are NOT automatically personal targets.
*
*W007 must verify profile applicability before using them.
*==============================================================================*/

references:{


/*==============================================================================*
*R001
*ADULT PHYSICAL ACTIVITY
*==============================================================================*/

who_adult_physical_activity:{

    id:"who_adult_physical_activity",

    authority:"World Health Organization",

    shortAuthority:"WHO",

    domain:"movement",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Reproductive Years",

            "Planning Pregnancy",

            "Perimenopause",

            "Menopause"

        ],

        diabetesProfile:[

            "Prediabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Previous Gestational Diabetes",

            "Not Sure"

        ]

    },


    statement:

        "For adults, WHO recommends at least 150 minutes of moderate-intensity physical activity across the week, or an equivalent amount of vigorous activity. Additional health benefits may occur with higher amounts of activity.",


    conciseStatement:

        "WHO recommends adults build at least 150 minutes of moderate-intensity physical activity across the week.",


    interpretationRule:

        "Use only as a weekly general reference. Never convert this into a rigid daily target.",


    prohibited:[

        "Do not divide 150 minutes by seven and present the result as a daily requirement.",

        "Do not say a user failed or achieved a daily exercise target.",

        "Do not infer exercise intensity from activity name alone."

    ],


    sourceTitle:

        "WHO guidelines on physical activity and sedentary behaviour",

    sourceYear:2020,

    active:true

},


/*==============================================================================*
*R002
*PHYSICAL ACTIVITY — ADDITIONAL BENEFIT RANGE
*==============================================================================*/

who_adult_physical_activity_additional:{

    id:"who_adult_physical_activity_additional",

    authority:"World Health Organization",

    shortAuthority:"WHO",

    domain:"movement",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Reproductive Years",

            "Planning Pregnancy",

            "Perimenopause",

            "Menopause"

        ],

        diabetesProfile:[

            "Prediabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Previous Gestational Diabetes",

            "Not Sure"

        ]

    },


    statement:

        "WHO indicates that adults may gain additional health benefits by increasing moderate-intensity aerobic activity toward 300 minutes per week.",


    conciseStatement:

        "WHO notes additional health benefits may occur as weekly moderate activity increases toward 300 minutes.",


    interpretationRule:

        "Use only when useful for general context. Do not present 300 minutes as a required target.",


    prohibited:[

        "Do not present 300 minutes as mandatory.",

        "Do not grade the user's day against 300 minutes."

    ],


    sourceTitle:

        "WHO guidelines on physical activity and sedentary behaviour",

    sourceYear:2020,

    active:true

},


/*==============================================================================*
*R003
*PHYSICAL ACTIVITY AND DIABETES SELF-MANAGEMENT
*==============================================================================*/

ada_diabetes_physical_activity:{

    id:"ada_diabetes_physical_activity",

    authority:"American Diabetes Association",

    shortAuthority:"ADA",

    domain:"movement",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Reproductive Years",

            "Planning Pregnancy",

            "Postpartum",

            "Perimenopause",

            "Menopause"

        ],

        diabetesProfile:[

            "Prediabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Previous Gestational Diabetes"

        ]

    },


    statement:

        "The ADA recognizes regular physical activity as an important component of diabetes prevention, management, health behavior and overall well-being.",


    conciseStatement:

        "ADA guidance recognizes regular physical activity as an important part of diabetes-related self-management and well-being.",


    interpretationRule:

        "Use as context for movement. Never attribute an individual glucose change to a specific activity session.",


    prohibited:[

        "Do not say today's movement caused a glucose reading to rise or fall.",

        "Do not prescribe exercise intensity.",

        "Do not advise medication changes around exercise."

    ],


    sourceTitle:

        "Standards of Care in Diabetes—2026: Facilitating Positive Health Behaviors and Well-being",

    sourceYear:2026,

    active:true

},


/*==============================================================================*
*R004
*SLEEP AND DIABETES SELF-MANAGEMENT
*==============================================================================*/

ada_sleep_health:{

    id:"ada_sleep_health",

    authority:"American Diabetes Association",

    shortAuthority:"ADA",

    domain:"sleep",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Reproductive Years",

            "Planning Pregnancy",

            "Pregnant",

            "Postpartum",

            "Perimenopause",

            "Menopause"

        ],

        diabetesProfile:[

            "Prediabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Gestational Diabetes",

            "Previous Gestational Diabetes",

            "Not Sure"

        ]

    },


    statement:

        "ADA guidance recognizes sleep health as an important part of overall health behavior and diabetes-related well-being.",


    conciseStatement:

        "ADA guidance recognizes sleep health as an important part of diabetes-related well-being.",


    interpretationRule:

        "Use to explain why sleep is worth noticing. Never claim one night's sleep caused a glucose, mood or stress result.",


    prohibited:[

        "Do not claim poor sleep caused today's glucose pattern.",

        "Do not diagnose a sleep disorder.",

        "Do not prescribe sleep medication."

    ],


    sourceTitle:

        "Standards of Care in Diabetes—2026: Facilitating Positive Health Behaviors and Well-being",

    sourceYear:2026,

    active:true

},


/*==============================================================================*
*R005
*GENERAL ADULT SLEEP CONTEXT
*
*W007 uses a conservative 7–9 hour general adult reference.
*
*This is contextual guidance only.
*==============================================================================*/

adult_sleep_duration_reference:{

    id:"adult_sleep_duration_reference",

    authority:"General Adult Sleep Guidance",

    shortAuthority:"Sleep Guidance",

    domain:"sleep",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Reproductive Years",

            "Planning Pregnancy",

            "Perimenopause",

            "Menopause"

        ],

        diabetesProfile:[

            "Prediabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Previous Gestational Diabetes",

            "Not Sure"

        ]

    },


    referenceRange:{

        minimumHours:7,

        maximumHours:9

    },


    statement:

        "For most adults, a sleep duration of roughly 7 to 9 hours is commonly used as a general reference, while individual sleep needs can vary.",


    conciseStatement:

        "A general adult sleep reference is around 7–9 hours, although individual needs vary.",


    interpretationRule:

        "Use only as general context. Sleep quality remains separate from duration.",


    prohibited:[

        "Do not diagnose sleep deprivation.",

        "Do not call 7–9 hours a personalized medical prescription.",

        "Do not assume longer duration means good-quality sleep."

    ],


    sourceTitle:

        "General adult sleep-duration guidance",

    active:true

},


/*==============================================================================*
*R006
*PSYCHOSOCIAL WELL-BEING
*==============================================================================*/

ada_psychosocial_wellbeing:{

    id:"ada_psychosocial_wellbeing",

    authority:"American Diabetes Association",

    shortAuthority:"ADA",

    domain:"stress",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Reproductive Years",

            "Planning Pregnancy",

            "Pregnant",

            "Postpartum",

            "Perimenopause",

            "Menopause"

        ],

        diabetesProfile:[

            "Prediabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Gestational Diabetes",

            "Previous Gestational Diabetes",

            "Not Sure"

        ]

    },


    statement:

        "ADA guidance recognizes psychosocial well-being and healthy coping as relevant components of diabetes self-management and health behavior.",


    conciseStatement:

        "ADA guidance recognizes emotional and psychosocial well-being as relevant to diabetes self-management.",


    interpretationRule:

        "Use to explain why stress and mood are worth observing. Never diagnose a mental-health condition from W005.",


    prohibited:[

        "Do not diagnose anxiety.",

        "Do not diagnose depression.",

        "Do not claim stress caused a glucose change.",

        "Do not infer mental-health status from one daily check-in."

    ],


    sourceTitle:

        "Standards of Care in Diabetes—2026: Facilitating Positive Health Behaviors and Well-being",

    sourceYear:2026,

    active:true

},


/*==============================================================================*
*R007
*HEALTHY DIET — FRUIT AND VEGETABLE CONTEXT
*==============================================================================*/

who_healthy_diet_fruit_vegetables:{

    id:"who_healthy_diet_fruit_vegetables",

    authority:"World Health Organization",

    shortAuthority:"WHO",

    domain:"meal",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Reproductive Years",

            "Planning Pregnancy",

            "Pregnant",

            "Postpartum",

            "Perimenopause",

            "Menopause"

        ],

        diabetesProfile:[

            "Prediabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Gestational Diabetes",

            "Previous Gestational Diabetes",

            "Not Sure"

        ]

    },


    statement:

        "WHO healthy-diet guidance recommends that people older than 10 years aim for at least 400 grams of fruits and vegetables per day as part of an overall healthy diet.",


    conciseStatement:

        "WHO recommends at least 400 g of fruits and vegetables daily for people older than 10 years as part of a healthy diet.",


    interpretationRule:

        "This reference may provide general educational context only. W005 free-text meal descriptions cannot establish whether the user met this recommendation.",


    prohibited:[

        "Do not estimate grams of fruit or vegetables from free-text meal descriptions.",

        "Do not calculate percentage achievement.",

        "Do not label a meal healthy or unhealthy from incomplete W005 food text."

    ],


    sourceTitle:

        "WHO Healthy Diet Fact Sheet",

    sourceYear:2026,

    active:true

},


/*==============================================================================*
*R008
*DIABETES HEALTHY LIFESTYLE CONTEXT
*==============================================================================*/

niddk_diabetes_healthy_living:{

    id:"niddk_diabetes_healthy_living",

    authority:"National Institute of Diabetes and Digestive and Kidney Diseases",

    shortAuthority:"NIDDK",

    domain:"general",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Reproductive Years",

            "Planning Pregnancy",

            "Postpartum",

            "Perimenopause",

            "Menopause"

        ],

        diabetesProfile:[

            "Prediabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Previous Gestational Diabetes",

            "Not Sure"

        ]

    },


    statement:

        "NIDDK identifies healthy eating, physical activity, adequate sleep and other sustainable health behaviors as useful components of diabetes prevention and management.",


    conciseStatement:

        "NIDDK highlights healthy eating, movement and adequate sleep as useful parts of diabetes-related healthy living.",


    interpretationRule:

        "Use only as broad wellness context. Prefer a more specific approved reference when available.",


    prohibited:[

        "Do not convert general healthy-living guidance into personalized treatment.",

        "Do not imply all users require identical behaviors."

    ],


    sourceTitle:

        "Healthy Living with Diabetes",

    active:true

},


/*==============================================================================*
*R009
*PHYSICAL ACTIVITY MAY AFFECT BLOOD GLUCOSE
*
*IMPORTANT:
*This reference is mainly a SAFETY reference.
*It must not be used to claim causality from one recorded day.
*==============================================================================*/

niddk_activity_glucose_safety:{

    id:"niddk_activity_glucose_safety",

    authority:"National Institute of Diabetes and Digestive and Kidney Diseases",

    shortAuthority:"NIDDK",

    domain:"bloodSugar",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Reproductive Years",

            "Planning Pregnancy",

            "Postpartum",

            "Perimenopause",

            "Menopause"

        ],

        diabetesProfile:[

            "Type 1 Diabetes",

            "Type 2 Diabetes"

        ]

    },


    statement:

        "Physical activity can affect blood glucose, and the response can vary depending on the individual, activity and diabetes medicines.",


    conciseStatement:

        "Physical activity can affect blood glucose, but individual responses vary.",


    interpretationRule:

        "Use principally to prevent overinterpretation. Do not attribute a specific glucose reading to a specific activity session.",


    prohibited:[

        "Do not say a walk lowered today's glucose.",

        "Do not say exercise caused a glucose rise.",

        "Do not advise insulin or medication changes."

    ],


    sourceTitle:

        "NIDDK Healthy Living with Diabetes",

    active:true

},


/*==============================================================================*
*R010
*GLUCOSE GOALS ARE INDIVIDUALIZED
*==============================================================================*/

ada_individualized_glucose_goals:{

    id:"ada_individualized_glucose_goals",

    authority:"American Diabetes Association",

    shortAuthority:"ADA",

    domain:"bloodSugar",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Reproductive Years",

            "Planning Pregnancy",

            "Postpartum",

            "Perimenopause",

            "Menopause"

        ],

        diabetesProfile:[

            "Prediabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Previous Gestational Diabetes",

            "Not Sure"

        ]

    },


    statement:

        "ADA Standards emphasize that glucose goals and monitoring plans should be individualized according to the person's clinical circumstances.",


    conciseStatement:

        "Glucose goals are individualized, so TRESTLE does not grade your readings against a generic target.",


    interpretationRule:

        "Use to justify factual rather than generic good/bad glucose classifications.",


    prohibited:[

        "Do not label a reading controlled or uncontrolled solely from generic thresholds.",

        "Do not label readings good or bad.",

        "Do not provide medication changes."

    ],


    sourceTitle:

        "Standards of Care in Diabetes—2026",

    sourceYear:2026,

    active:true

},


/*==============================================================================*
*R011
*PREGNANCY / GESTATIONAL DIABETES SAFETY CONTEXT
*==============================================================================*/

pregnancy_glucose_individualized_care:{

    id:"pregnancy_glucose_individualized_care",

    authority:"Clinical Pregnancy Diabetes Guidance",

    shortAuthority:"Pregnancy Guidance",

    domain:"bloodSugar",

    evidenceClass:"C",

    appliesTo:{

        lifeStage:[

            "Pregnant"

        ],

        diabetesProfile:[

            "Gestational Diabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Prediabetes",

            "Not Sure"

        ]

    },


    statement:

        "During pregnancy, glucose monitoring and treatment targets should be guided by the woman's obstetric and diabetes care team.",


    conciseStatement:

        "During pregnancy, glucose targets should follow the plan agreed with the obstetric or diabetes care team.",


    interpretationRule:

        "Activates pregnancy safety mode. Do not apply ordinary nonpregnancy glucose references.",


    prohibited:[

        "Do not substitute generic adult glucose targets.",

        "Do not recommend treatment changes.",

        "Do not interpret gestational diabetes readings independently of clinician-set goals."

    ],


    sourceTitle:

        "Pregnancy and diabetes clinical guidance",

    active:true

}

},


/*==============================================================================*
*REFERENCE DOMAIN PRIORITY
*
*Used later by the W007 engine when selecting a maximum of two references.
*==============================================================================*/

referencePriority:{

    sleep:90,

    movement:85,

    bloodSugar:80,

    stress:75,

    meal:60,

    general:40,

    water:0,

    mood:0,

    medication:0

},


/*==============================================================================*
*REFERENCE DISPLAY RULES
*==============================================================================*/

referenceDisplayRules:{

    maximumPerInsight:2,

    showAuthority:true,

    showSourceTitle:true,

    showSourceYearWhenAvailable:true,

    showGeneralReferenceDisclaimer:true,

    disclaimer:

        "General health guidance provides context only and is not a personal medical target or treatment recommendation."

},


/*==============================================================================*
*SECTION A END
*
*SECTION B WILL CONTINUE INSIDE THIS SAME ROOT OBJECT.
*
*DO NOT CLOSE TRESTLE_W007_INSIGHT_DATA YET.
*==============================================================================*/
/*==============================================================================*
*PROMISE RULES
*
*The Promise does NOT create evidence.
*
*It determines which VALID recorded observations deserve higher priority.
*==============================================================================*/

promiseRules:{


/*==============================================================================*
*BALANCED LIFE
*==============================================================================*/

"Balanced Life":{

    id:"promise_balanced_life",

    label:"Balanced Life",

    primaryDomains:[

        "stress",

        "movement",

        "sleep",

        "meal"

    ],

    secondaryDomains:[

        "mood",

        "water"

    ],

    prohibitedDomains:[

        "bloodSugarDiagnosis",

        "medicationAdjustment"

    ],


    priorities:{

        stress:95,

        movement:90,

        sleep:85,

        meal:80,

        mood:65,

        water:50,

        bloodSugar:40,

        medication:35

    },


    positivePatterns:[

        "movement_recorded",

        "multiple_movement_sessions",

        "sleep_quality_good",

        "stress_low",

        "mood_good",

        "meal_sequence_available"

    ],


    attentionPatterns:[

        "stress_high",

        "sleep_quality_poor",

        "clearly_shorter_sleep",

        "long_recorded_meal_interval"

    ],


    reflectionVariants:[

        "Your Balanced Life Promise is about the shape of the whole day rather than getting every part perfect.",

        "Balanced Life does not require every part of the day to go exactly to plan. TRESTLE looks for the clearest thing worth noticing.",

        "Your Balanced Life Promise works best when the day is viewed as a whole rather than as a score."

    ],


    maintainSuccessVariants:[

        "Some of what you recorded already sits well with your Balanced Life Promise. The useful next step may simply be to protect what worked.",

        "Yesterday included behaviours that already moved in the direction of your Balanced Life Promise. You do not always need to add something new.",

        "Your entries show at least one part of the day already supporting your Balanced Life Promise. Repeating that can be enough."

    ],


    sparseDataVariant:

        "Your Balanced Life Promise remains your direction, but today's recorded information is too limited for TRESTLE to identify a specific pattern without guessing."

},


/*==============================================================================*
*MORE ENERGY
*
*W005 does NOT directly measure energy.
*
*Therefore W007 must never claim that the user had high or low energy unless
*that becomes an explicit future input.
*==============================================================================*/

"More Energy":{

    id:"promise_more_energy",

    label:"More Energy",

    primaryDomains:[

        "sleep",

        "meal",

        "movement"

    ],

    secondaryDomains:[

        "stress",

        "mood",

        "water"

    ],


    priorities:{

        sleep:100,

        meal:90,

        movement:85,

        stress:70,

        mood:55,

        water:45,

        bloodSugar:40,

        medication:30

    },


    positivePatterns:[

        "sleep_quality_good",

        "adult_sleep_reference_met",

        "movement_recorded",

        "multiple_movement_sessions",

        "meal_sequence_available"

    ],


    attentionPatterns:[

        "clearly_shorter_sleep",

        "shorter_sleep",

        "sleep_quality_poor",

        "long_recorded_meal_interval"

    ],


    reflectionVariants:[

        "Because More Energy is your Promise, TRESTLE gives priority to the parts of your day that can reasonably support day-to-day energy without pretending to measure energy itself.",

        "Your More Energy Promise helps TRESTLE decide what deserves attention, but your check-ins do not directly measure energy.",

        "For a More Energy Promise, sleep, meal rhythm and movement are useful places to look first when your own entries support them."

    ],


    maintainSuccessVariants:[

        "Yesterday included a behaviour that already supports the direction of your More Energy Promise. Repeating what worked may be more useful than adding another task.",

        "Some of yesterday's recorded habits already point in the direction of your More Energy Promise. Protecting one of them is enough for today.",

        "Your More Energy Promise does not always require a correction. A useful focus can simply be to repeat a supportive routine you already recorded."

    ],


    sparseDataVariant:

        "Your Promise is More Energy. TRESTLE does not have enough relevant recorded information today to suggest a specific focus without making assumptions."

},


/*==============================================================================*
*BETTER SLEEP
*==============================================================================*/

"Better Sleep":{

    id:"promise_better_sleep",

    label:"Better Sleep",

    primaryDomains:[

        "sleep",

        "stress",

        "meal"

    ],

    secondaryDomains:[

        "movement",

        "mood"

    ],


    priorities:{

        sleep:110,

        stress:90,

        meal:75,

        movement:60,

        mood:55,

        water:20,

        bloodSugar:20,

        medication:20

    },


    positivePatterns:[

        "adult_sleep_reference_met",

        "sleep_quality_good",

        "stress_low"

    ],


    attentionPatterns:[

        "clearly_shorter_sleep",

        "shorter_sleep",

        "sleep_quality_poor",

        "stress_high",

        "later_evening_meal_recorded"

    ],


    reflectionVariants:[

        "Better Sleep is your Promise, so sleep-related information receives first priority whenever you record enough to interpret it responsibly.",

        "Because you chose Better Sleep, TRESTLE looks first at the sleep information you recorded and only then at supporting parts of the day.",

        "Your Better Sleep Promise gives today's sleep entry special relevance, while TRESTLE avoids claiming that any single daytime event caused the night you had."

    ],


    maintainSuccessVariants:[

        "Yesterday's sleep entry sat well with your Better Sleep Promise. Rather than changing something, today's focus can simply be to protect the routine that worked.",

        "Your recorded sleep already moved in the direction of your Better Sleep Promise. Maintaining a helpful routine can be more valuable than adding a new one.",

        "Nothing in a Better Sleep Promise says TRESTLE must always find a problem. Yesterday's sleep entry gives you something worth protecting."

    ],


    sparseDataVariant:

        "Your Promise is Better Sleep, but there is not enough sleep-related information recorded today for TRESTLE to identify a specific pattern without guessing."

},


/*==============================================================================*
*MORE CALMNESS
*==============================================================================*/

"More Calmness":{

    id:"promise_more_calmness",

    label:"More Calmness",

    primaryDomains:[

        "stress",

        "mood",

        "sleep"

    ],

    secondaryDomains:[

        "movement"

    ],


    priorities:{

        stress:110,

        mood:90,

        sleep:85,

        movement:65,

        meal:40,

        water:25,

        bloodSugar:20,

        medication:20

    },


    positivePatterns:[

        "stress_low",

        "mood_good",

        "sleep_quality_good",

        "movement_recorded"

    ],


    attentionPatterns:[

        "stress_high",

        "mood_low",

        "sleep_quality_poor",

        "clearly_shorter_sleep"

    ],


    reflectionVariants:[

        "Your More Calmness Promise does not mean every day must feel calm. It gives TRESTLE a reason to pay closer attention to how you described stress, mood and recovery.",

        "For your More Calmness Promise, TRESTLE gives priority to the way you described stress and mood rather than trying to judge whether the entire day was good or bad.",

        "More Calmness is a direction, not a requirement to feel calm all day. Your own stress and mood check-ins provide the useful evidence."

    ],


    maintainSuccessVariants:[

        "Yesterday included a calmer signal worth protecting. Your More Calmness Promise may be served best by noticing what was different rather than introducing a new task.",

        "Some of yesterday's entries already sat comfortably with your More Calmness Promise. The next step can simply be to protect what helped the day feel manageable.",

        "Your More Calmness Promise does not require constant correction. A low-stress or positive-mood day is something worth noticing and preserving."

    ],


    sparseDataVariant:

        "Your Promise is More Calmness, but TRESTLE does not have enough stress, mood or recovery information recorded today to identify a specific focus responsibly."

},


/*==============================================================================*
*BETTER FOCUS
*
*W005 does NOT directly measure concentration or productivity.
*
*Therefore W007 may prioritize relevant supporting factors but may not claim
*that focus itself was good or poor.
*==============================================================================*/

"Better Focus":{

    id:"promise_better_focus",

    label:"Better Focus",

    primaryDomains:[

        "stress",

        "sleep",

        "meal"

    ],

    secondaryDomains:[

        "movement",

        "mood"

    ],


    priorities:{

        stress:100,

        sleep:95,

        meal:85,

        movement:65,

        mood:55,

        water:30,

        bloodSugar:30,

        medication:25

    },


    positivePatterns:[

        "stress_low",

        "sleep_quality_good",

        "adult_sleep_reference_met",

        "movement_recorded",

        "meal_sequence_available"

    ],


    attentionPatterns:[

        "stress_high",

        "clearly_shorter_sleep",

        "shorter_sleep",

        "sleep_quality_poor",

        "long_recorded_meal_interval"

    ],


    reflectionVariants:[

        "Better Focus is your Promise, but W005 does not measure concentration directly. TRESTLE therefore looks only at supporting parts of your day that you actually recorded.",

        "Your Better Focus Promise helps prioritize sleep, stress and meal rhythm when they are available, without pretending that TRESTLE measured your concentration.",

        "Because focus itself was not directly recorded, TRESTLE uses your Better Focus Promise only to rank relevant supporting observations."

    ],


    maintainSuccessVariants:[

        "Some of yesterday's recorded habits already support the direction of your Better Focus Promise. Repeating what worked can be the most useful next step.",

        "There is no need to invent a problem when yesterday included supportive routines. Protecting one of those routines may be enough for your Better Focus Promise.",

        "Your Better Focus Promise can sometimes be served by maintaining yesterday's supportive rhythm rather than adding another task."

    ],


    sparseDataVariant:

        "Your Promise is Better Focus. Because focus is not directly measured and today's supporting data is limited, TRESTLE will not invent a specific explanation or recommendation."

},


/*==============================================================================*
*HEALTHIER LIVING
*==============================================================================*/

"Healthier Living":{

    id:"promise_healthier_living",

    label:"Healthier Living",

    primaryDomains:[

        "movement",

        "sleep",

        "meal",

        "water"

    ],

    secondaryDomains:[

        "stress",

        "mood",

        "medication"

    ],


    priorities:{

        movement:105,

        sleep:95,

        meal:85,

        water:65,

        stress:55,

        mood:45,

        medication:40,

        bloodSugar:35

    },


    positivePatterns:[

        "movement_recorded",

        "multiple_movement_sessions",

        "adult_sleep_reference_met",

        "sleep_quality_good",

        "meal_sequence_available",

        "water_logged"

    ],


    attentionPatterns:[

        "clearly_shorter_sleep",

        "sleep_quality_poor",

        "long_recorded_meal_interval",

        "stress_high"

    ],


    reflectionVariants:[

        "Your Healthier Living Promise is best supported by sustainable behaviours rather than a perfect day.",

        "For Healthier Living, TRESTLE looks first for useful behaviours already present in your day before searching for something to change.",

        "Healthier Living is built from repeatable actions. Your recorded movement, sleep and meal awareness therefore carry more weight than any single isolated metric."

    ],


    maintainSuccessVariants:[

        "Yesterday already contained a behaviour moving in the direction of your Healthier Living Promise. Repeating it is a legitimate next step.",

        "Your Healthier Living Promise does not require adding something new every day. Protecting a behaviour that already worked can be enough.",

        "One sustainable behaviour repeated is more useful than several changes attempted at once. Yesterday gives you something worth carrying forward."

    ],


    sparseDataVariant:

        "Your Promise is Healthier Living, but today's recorded information is too limited for TRESTLE to identify a specific evidence-based focus without guessing."

}

},


/*==============================================================================*
*PROMISE DOMAIN PRIORITY MAP
*
*Fast lookup for the W007 engine.
*==============================================================================*/

promiseDomainPriority:{

    "Balanced Life":{

        stress:95,

        movement:90,

        sleep:85,

        meal:80,

        mood:65,

        water:50,

        bloodSugar:40,

        medication:35

    },


    "More Energy":{

        sleep:100,

        meal:90,

        movement:85,

        stress:70,

        mood:55,

        water:45,

        bloodSugar:40,

        medication:30

    },


    "Better Sleep":{

        sleep:110,

        stress:90,

        meal:75,

        movement:60,

        mood:55,

        water:20,

        bloodSugar:20,

        medication:20

    },


    "More Calmness":{

        stress:110,

        mood:90,

        sleep:85,

        movement:65,

        meal:40,

        water:25,

        bloodSugar:20,

        medication:20

    },


    "Better Focus":{

        stress:100,

        sleep:95,

        meal:85,

        movement:65,

        mood:55,

        water:30,

        bloodSugar:30,

        medication:25

    },


    "Healthier Living":{

        movement:105,

        sleep:95,

        meal:85,

        water:65,

        stress:55,

        mood:45,

        medication:40,

        bloodSugar:35

    }

},


/*==============================================================================*
*PROMISE SAFETY RULES
*==============================================================================*/

promiseSafetyRules:{


    /*--------------------------------------------------------------------------
    MORE ENERGY
    --------------------------------------------------------------------------*/

    "More Energy":{

        prohibitedClaims:[

            "You had low energy.",

            "You had high energy.",

            "Your sleep caused your energy level.",

            "Your meal timing caused low energy.",

            "Your movement increased your energy today."

        ],

        reason:

            "W005 does not directly measure energy."

    },


    /*--------------------------------------------------------------------------
    BETTER FOCUS
    --------------------------------------------------------------------------*/

    "Better Focus":{

        prohibitedClaims:[

            "You were unfocused.",

            "Your focus was poor.",

            "Your focus improved.",

            "Your stress caused poor concentration.",

            "Your sleep caused poor focus."

        ],

        reason:

            "W005 does not directly measure concentration or productivity."

    },


    /*--------------------------------------------------------------------------
    BETTER SLEEP
    --------------------------------------------------------------------------*/

    "Better Sleep":{

        prohibitedClaims:[

            "Your dinner caused poor sleep.",

            "Your stress caused poor sleep.",

            "Your movement improved your sleep.",

            "You have a sleep disorder."

        ],

        reason:

            "Single-day entries permit observation but not causal or diagnostic conclusions."

    },


    /*--------------------------------------------------------------------------
    MORE CALMNESS
    --------------------------------------------------------------------------*/

    "More Calmness":{

        prohibitedClaims:[

            "You were anxious.",

            "You have anxiety.",

            "Your stress caused your mood.",

            "Your movement made you calmer."

        ],

        reason:

            "Stress and mood entries are self-reported states, not clinical assessments."

    },


    /*--------------------------------------------------------------------------
    BALANCED LIFE
    --------------------------------------------------------------------------*/

    "Balanced Life":{

        prohibitedClaims:[

            "Your life was unbalanced.",

            "You failed to achieve balance.",

            "Your health day was poor."

        ],

        reason:

            "Balanced Life is a user-selected direction, not a measurable diagnostic state."

    },


    /*--------------------------------------------------------------------------
    HEALTHIER LIVING
    --------------------------------------------------------------------------*/

    "Healthier Living":{

        prohibitedClaims:[

            "You lived unhealthily today.",

            "Your meal was unhealthy.",

            "Your water intake was inadequate.",

            "You failed your healthy-living target."

        ],

        reason:

            "W005 provides incomplete daily observations and does not support a global health score."

    }

},


/*==============================================================================*
*PROMISE POSITIVE-RULE WEIGHTS
*
*Used to rank valid positive observations for Promise alignment.
*==============================================================================*/

promisePositiveWeights:{

    movement_recorded:85,

    multiple_movement_sessions:95,

    sleep_quality_good:85,

    adult_sleep_reference_met:90,

    stress_low:80,

    mood_good:70,

    meal_sequence_available:65,

    medication_taken:55,

    water_logged:40,

    multiple_glucose_readings:45

},


/*==============================================================================*
*PROMISE ATTENTION-RULE WEIGHTS
*
*These do NOT mean "bad".
*
*They identify observations potentially useful for Promise-linked reflection.
*==============================================================================*/

promiseAttentionWeights:{

    clearly_shorter_sleep:100,

    shorter_sleep:85,

    sleep_quality_poor:95,

    stress_high:95,

    mood_low:70,

    long_recorded_meal_interval:75,

    later_evening_meal_recorded:55,

    medication_missed:90,

    contextual_glucose_comparison_available:45

},


/*==============================================================================*
*PROMISE FALLBACK ORDER
*
*If the highest-priority Promise domain contains no usable evidence,
*the engine checks the next domain.
*==============================================================================*/

promiseFallbackOrder:{

    "Balanced Life":[

        "stress",

        "movement",

        "sleep",

        "meal",

        "mood",

        "water"

    ],


    "More Energy":[

        "sleep",

        "meal",

        "movement",

        "stress",

        "mood",

        "water"

    ],


    "Better Sleep":[

        "sleep",

        "stress",

        "meal",

        "movement",

        "mood"

    ],


    "More Calmness":[

        "stress",

        "mood",

        "sleep",

        "movement"

    ],


    "Better Focus":[

        "stress",

        "sleep",

        "meal",

        "movement",

        "mood"

    ],


    "Healthier Living":[

        "movement",

        "sleep",

        "meal",

        "water",

        "stress",

        "mood"

    ]

},


/*==============================================================================*
*PROMISE OUTPUT LIMITS
*==============================================================================*/

promiseOutputRules:{

    maximumReflectionParagraphs:1,

    maximumFocusItems:1,

    preferPromiseRelevantEvidence:true,

    preferRecordedSuccessBeforeGenericAdvice:true,

    allowMaintainSuccess:true,

    neverForceNegativeInterpretation:true,

    neverInferMissingData:true,

    neverUsePromiseAsMedicalEvidence:true

},


/*==============================================================================*
*SECTION B END
*
*SECTION C WILL CONTINUE INSIDE THIS SAME ROOT OBJECT.
*
*DO NOT CLOSE TRESTLE_W007_INSIGHT_DATA YET.
*==============================================================================*/
/*==============================================================================*
*LIFE STAGE RULES
*
*Life Stage provides CONTEXT.
*
*It does NOT create evidence about today's health.
*
*W007 may use Life Stage to:
*
*1. Rank relevant scientific context.
*2. Apply additional safety restrictions.
*3. Modify wording.
*4. Decide whether a general reference is appropriate.
*
*W007 must NEVER use Life Stage to claim that a symptom, glucose reading,
*sleep pattern, mood or stress level was CAUSED by that Life Stage.
*==============================================================================*/

lifeStageRules:{


/*==============================================================================*
*REPRODUCTIVE YEARS
*==============================================================================*/

"Reproductive Years":{

    id:"life_stage_reproductive_years",

    label:"Reproductive Years",

    safetyMode:"STANDARD",

    referenceMode:"GENERAL_ADULT",

    priorityDomains:[

        "movement",

        "sleep",

        "stress",

        "meal",

        "mood"

    ],


    allowedReferenceDomains:[

        "movement",

        "sleep",

        "stress",

        "meal",

        "general",

        "bloodSugar"

    ],


    contextVariants:[

        "Your life-stage profile provides general adult context for today's TRESTLE reflection.",

        "TRESTLE uses your Reproductive Years profile only to select relevant general wellness context; today's conclusions still come from what you actually recorded.",

        "Your life stage helps TRESTLE choose appropriate context, but it does not explain any individual reading or symptom."

    ],


    prohibitedClaims:[

        "Your reproductive stage caused your glucose pattern.",

        "Your reproductive stage caused your mood.",

        "Your reproductive stage caused your stress.",

        "Your reproductive stage caused your sleep pattern."

    ]

},


/*==============================================================================*
*PLANNING PREGNANCY
*==============================================================================*/

"Planning Pregnancy":{

    id:"life_stage_planning_pregnancy",

    label:"Planning Pregnancy",

    safetyMode:"PRECONCEPTION_CAUTION",

    referenceMode:"GENERAL_ADULT_WITH_PRECONCEPTION_CAUTION",

    priorityDomains:[

        "sleep",

        "movement",

        "meal",

        "stress",

        "bloodSugar",

        "medication"

    ],


    allowedReferenceDomains:[

        "movement",

        "sleep",

        "stress",

        "meal",

        "general",

        "bloodSugar"

    ],


    elevatedCautionDomains:[

        "bloodSugar",

        "medication",

        "exercise",

        "nutritionSupplementation"

    ],


    contextVariants:[

        "Because you are planning pregnancy, TRESTLE keeps health guidance conservative and avoids changing treatment, medicines or clinician-set targets.",

        "Your Planning Pregnancy profile makes TRESTLE more cautious with glucose, medicines and health recommendations while still reflecting what you recorded.",

        "For someone planning pregnancy, TRESTLE uses general wellness context carefully and leaves treatment decisions to your healthcare professional."

    ],


    doctorQuestionPreference:[

        "bloodSugar",

        "medication",

        "sleep"

    ],


    prohibitedClaims:[

        "Your current glucose pattern affects fertility.",

        "You should change medication before pregnancy.",

        "You should start or stop a supplement.",

        "A particular meal improves fertility.",

        "A single recorded behavior improves pregnancy chances."

    ]

},


/*==============================================================================*
*PREGNANT
*==============================================================================*/

"Pregnant":{

    id:"life_stage_pregnant",

    label:"Pregnant",

    safetyMode:"PREGNANCY_SAFETY",

    referenceMode:"PREGNANCY_SPECIFIC_WHERE_AVAILABLE",

    priorityDomains:[

        "bloodSugar",

        "medication",

        "sleep",

        "movement",

        "meal",

        "stress"

    ],


    allowedReferenceDomains:[

        "sleep",

        "stress",

        "general",

        "bloodSugar"

    ],


    restrictedReferenceDomains:[

        "movement_general_adult",

        "glucose_general_adult",

        "weight_general_adult",

        "nutrition_general_target"

    ],


    elevatedCautionDomains:[

        "bloodSugar",

        "medication",

        "movement",

        "nutrition",

        "symptoms"

    ],


    contextVariants:[

        "Because you are pregnant, TRESTLE uses a more cautious interpretation mode and does not substitute general adult targets for the plan given by your obstetric or diabetes care team.",

        "Your pregnancy profile activates additional safety rules. TRESTLE reflects what you recorded but leaves glucose targets, medicines and treatment decisions to your clinical team.",

        "During pregnancy, today's entries are treated as information for reflection and discussion rather than as a basis for independent treatment advice."

    ],


    doctorQuestionPreference:[

        "bloodSugar",

        "medication",

        "sleep",

        "stress"

    ],


    doctorQuestionThreshold:"LOWER_FOR_RECURRING_CLINICAL_PATTERNS",


    prohibitedClaims:[

        "This glucose reading is normal for pregnancy.",

        "This glucose reading is abnormal for pregnancy.",

        "You should change insulin.",

        "You should change medication.",

        "You should exercise for a prescribed amount without clinician context.",

        "A specific food caused your pregnancy glucose pattern.",

        "Your stress caused a pregnancy-related glucose change.",

        "TRESTLE knows your pregnancy glucose target."

    ]

},


/*==============================================================================*
*POSTPARTUM
*==============================================================================*/

"Postpartum":{

    id:"life_stage_postpartum",

    label:"Postpartum",

    safetyMode:"POSTPARTUM_CAUTION",

    referenceMode:"POSTPARTUM_CONTEXT_WHERE_AVAILABLE",

    priorityDomains:[

        "sleep",

        "stress",

        "mood",

        "movement",

        "meal",

        "bloodSugar"

    ],


    allowedReferenceDomains:[

        "sleep",

        "stress",

        "movement",

        "general",

        "bloodSugar"

    ],


    elevatedCautionDomains:[

        "mood",

        "sleep",

        "movement",

        "medication"

    ],


    contextVariants:[

        "Your Postpartum profile gives extra context to sleep, stress, mood and recovery, but TRESTLE does not assume that postpartum changes caused any particular entry.",

        "Because you are postpartum, TRESTLE treats sleep, mood and recovery information with additional care and avoids turning one day's entries into a diagnosis.",

        "Postpartum life can change the shape of a day considerably. TRESTLE reflects only what you recorded and avoids judging missing or irregular routines."

    ],


    doctorQuestionPreference:[

        "sleep",

        "mood",

        "bloodSugar",

        "medication"

    ],


    prohibitedClaims:[

        "You have postpartum depression.",

        "Your postpartum stage caused your mood.",

        "Your postpartum stage caused your glucose pattern.",

        "You should begin or intensify exercise without appropriate clinical context.",

        "Your sleep is inadequate because you are postpartum."

    ]

},


/*==============================================================================*
*PERIMENOPAUSE
*==============================================================================*/

"Perimenopause":{

    id:"life_stage_perimenopause",

    label:"Perimenopause",

    safetyMode:"STANDARD_WITH_HORMONAL_CAUTION",

    referenceMode:"GENERAL_ADULT_WITH_LIFE_STAGE_CONTEXT",

    priorityDomains:[

        "sleep",

        "stress",

        "mood",

        "movement",

        "meal",

        "bloodSugar"

    ],


    allowedReferenceDomains:[

        "movement",

        "sleep",

        "stress",

        "meal",

        "general",

        "bloodSugar"

    ],


    contextualDomains:[

        "sleep",

        "mood",

        "stress"

    ],


    contextVariants:[

        "Your Perimenopause profile makes sleep, mood and stress useful areas of context, but TRESTLE does not assume hormonal change caused anything you recorded today.",

        "Perimenopause can be relevant to how women experience sleep and well-being, but today's TRESTLE Insight stays anchored to your own recorded information.",

        "Your life stage helps TRESTLE prioritize appropriate context while avoiding assumptions that today's glucose, mood or sleep pattern was caused by hormones."

    ],


    doctorQuestionPreference:[

        "sleep",

        "mood",

        "bloodSugar"

    ],


    prohibitedClaims:[

        "Perimenopause caused your poor sleep.",

        "Perimenopause caused your mood change.",

        "Perimenopause caused your glucose reading.",

        "Your hormones caused today's stress.",

        "You need hormone treatment.",

        "Your symptoms confirm perimenopause."

    ]

},


/*==============================================================================*
*MENOPAUSE
*==============================================================================*/

"Menopause":{

    id:"life_stage_menopause",

    label:"Menopause",

    safetyMode:"STANDARD_WITH_HORMONAL_CAUTION",

    referenceMode:"GENERAL_ADULT_WITH_LIFE_STAGE_CONTEXT",

    priorityDomains:[

        "sleep",

        "movement",

        "stress",

        "mood",

        "meal",

        "bloodSugar"

    ],


    allowedReferenceDomains:[

        "movement",

        "sleep",

        "stress",

        "meal",

        "general",

        "bloodSugar"

    ],


    contextualDomains:[

        "sleep",

        "mood",

        "stress",

        "movement"

    ],


    contextVariants:[

        "Your Menopause profile gives additional context to sleep, mood, movement and overall well-being, while today's Insight remains based on what you actually recorded.",

        "Menopause is part of your wider health context, but TRESTLE does not use it to explain a single day's glucose, mood, stress or sleep pattern.",

        "Your life stage helps TRESTLE choose relevant context without turning normal variation in one day into a hormonal conclusion."

    ],


    doctorQuestionPreference:[

        "sleep",

        "mood",

        "bloodSugar"

    ],


    prohibitedClaims:[

        "Menopause caused your glucose pattern.",

        "Menopause caused your poor sleep.",

        "Menopause caused your mood.",

        "Your hormones caused today's stress.",

        "You require hormone treatment.",

        "Your recorded symptoms confirm a menopause-related disorder."

    ]

}

},


/*==============================================================================*
*LIFE-STAGE DOMAIN PRIORITY
*
*Used as a secondary modifier after Promise priority.
*
*Promise remains the main personalization direction.
*Life Stage adjusts relevance and safety.
*==============================================================================*/

lifeStageDomainPriority:{


    "Reproductive Years":{

        movement:80,

        sleep:80,

        stress:75,

        meal:70,

        mood:65,

        bloodSugar:60,

        medication:50,

        water:40

    },


    "Planning Pregnancy":{

        sleep:85,

        movement:80,

        meal:80,

        stress:75,

        bloodSugar:85,

        medication:90,

        mood:60,

        water:40

    },


    "Pregnant":{

        bloodSugar:110,

        medication:105,

        sleep:90,

        stress:85,

        meal:80,

        movement:70,

        mood:70,

        water:40

    },


    "Postpartum":{

        sleep:105,

        stress:95,

        mood:95,

        movement:75,

        meal:70,

        bloodSugar:70,

        medication:65,

        water:40

    },


    "Perimenopause":{

        sleep:100,

        stress:90,

        mood:85,

        movement:80,

        meal:70,

        bloodSugar:70,

        medication:50,

        water:40

    },


    "Menopause":{

        sleep:95,

        movement:90,

        stress:85,

        mood:80,

        meal:70,

        bloodSugar:70,

        medication:50,

        water:40

    }

},


/*==============================================================================*
*SAFETY MODES
*==============================================================================*/

lifeStageSafetyModes:{


    STANDARD:{

        id:"STANDARD",

        allowGeneralAdultReferences:true,

        requirePregnancySpecificReferences:false,

        blockGenericGlucoseTargets:true,

        blockMedicationAdvice:true,

        blockDiagnosis:true

    },


    PRECONCEPTION_CAUTION:{

        id:"PRECONCEPTION_CAUTION",

        allowGeneralAdultReferences:true,

        requirePregnancySpecificReferences:false,

        blockGenericGlucoseTargets:true,

        blockMedicationAdvice:true,

        blockSupplementAdvice:true,

        blockDiagnosis:true,

        increaseDoctorQuestionPriorityFor:[

            "medication",

            "bloodSugar"

        ]

    },


    PREGNANCY_SAFETY:{

        id:"PREGNANCY_SAFETY",

        allowGeneralAdultReferences:false,

        requirePregnancySpecificReferences:true,

        blockGenericGlucoseTargets:true,

        blockMedicationAdvice:true,

        blockExercisePrescription:true,

        blockDietPrescription:true,

        blockDiagnosis:true,

        increaseDoctorQuestionPriorityFor:[

            "bloodSugar",

            "medication"

        ]

    },


    POSTPARTUM_CAUTION:{

        id:"POSTPARTUM_CAUTION",

        allowGeneralAdultReferences:true,

        requirePregnancySpecificReferences:false,

        blockGenericGlucoseTargets:true,

        blockMedicationAdvice:true,

        blockMentalHealthDiagnosis:true,

        blockExercisePrescription:true,

        blockDiagnosis:true,

        increaseDoctorQuestionPriorityFor:[

            "mood",

            "sleep"

        ]

    },


    STANDARD_WITH_HORMONAL_CAUTION:{

        id:"STANDARD_WITH_HORMONAL_CAUTION",

        allowGeneralAdultReferences:true,

        requirePregnancySpecificReferences:false,

        blockGenericGlucoseTargets:true,

        blockMedicationAdvice:true,

        blockHormonalCausation:true,

        blockDiagnosis:true

    }

},


/*==============================================================================*
*LIFE-STAGE CONTEXTUAL OBSERVATION RULES
*
*These rules allow W007 to mention WHY a domain deserves attention
*without claiming that Life Stage caused the day's result.
*==============================================================================*/

lifeStageContextRules:{


    perimenopause_sleep:{

        id:"perimenopause_sleep",

        lifeStage:"Perimenopause",

        domain:"sleep",

        requiresAny:[

            "sleep_recorded",

            "sleep_quality_poor",

            "shorter_sleep",

            "clearly_shorter_sleep"

        ],

        allowedTextVariants:[

            "Because sleep can be a useful area to notice during perimenopause, your recorded sleep deserves context without assuming hormones caused the night you had.",

            "Your Perimenopause profile makes sleep a relevant area to keep noticing, while today's entry remains a single observation rather than a hormonal conclusion."

        ],

        prohibited:[

            "Perimenopause caused your sleep problem."

        ],

        priority:70,

        active:true

    },


    menopause_sleep:{

        id:"menopause_sleep",

        lifeStage:"Menopause",

        domain:"sleep",

        requiresAny:[

            "sleep_recorded",

            "sleep_quality_poor",

            "shorter_sleep",

            "clearly_shorter_sleep"

        ],

        allowedTextVariants:[

            "Sleep remains a useful area to notice during menopause, but TRESTLE does not assume that your life stage caused today's sleep pattern.",

            "Your Menopause profile gives additional context to sleep, while today's entry is treated only as what you actually recorded."

        ],

        prohibited:[

            "Menopause caused your poor sleep."

        ],

        priority:70,

        active:true

    },


    postpartum_sleep:{

        id:"postpartum_sleep",

        lifeStage:"Postpartum",

        domain:"sleep",

        requiresAny:[

            "sleep_recorded",

            "sleep_quality_poor",

            "shorter_sleep",

            "clearly_shorter_sleep"

        ],

        allowedTextVariants:[

            "Your Postpartum profile makes sleep and recovery particularly useful areas to observe, without treating one night's entry as a diagnosis.",

            "Postpartum days can have unusual rhythms. Your sleep entry is therefore worth recording without judging it against an idealized day."

        ],

        priority:75,

        active:true

    },


    postpartum_mood:{

        id:"postpartum_mood",

        lifeStage:"Postpartum",

        domain:"mood",

        requiresAny:[

            "mood_recorded"

        ],

        allowedTextVariants:[

            "Your mood check-in is useful context during the postpartum period, but one daily entry is not a mental-health assessment.",

            "TRESTLE can reflect how you described your mood today while leaving any clinical interpretation to an appropriate healthcare professional."

        ],

        prohibited:[

            "You have postpartum depression.",

            "Your postpartum stage caused your mood."

        ],

        priority:80,

        active:true

    },


    pregnancy_glucose:{

        id:"pregnancy_glucose",

        lifeStage:"Pregnant",

        domain:"bloodSugar",

        requiresAny:[

            "glucose_reading_recorded",

            "multiple_glucose_readings"

        ],

        allowedTextVariants:[

            "Because you are pregnant, your glucose readings are best understood against the targets agreed with your obstetric or diabetes care team.",

            "During pregnancy, TRESTLE records glucose context but does not grade readings against generic adult targets."

        ],

        prohibited:[

            "This is a normal pregnancy glucose reading.",

            "This is an abnormal pregnancy glucose reading."

        ],

        priority:110,

        active:true

    }

},


/*==============================================================================*
*LIFE-STAGE DOCTOR-QUESTION MODIFIERS
*
*These do not automatically create questions.
*
*They increase or decrease the relevance of an already-supported question.
*==============================================================================*/

lifeStageDoctorQuestionModifiers:{


    "Reproductive Years":{

        multiplier:1.0

    },


    "Planning Pregnancy":{

        multiplier:1.15,

        boostedDomains:[

            "medication",

            "bloodSugar"

        ]

    },


    "Pregnant":{

        multiplier:1.35,

        boostedDomains:[

            "bloodSugar",

            "medication"

        ]

    },


    "Postpartum":{

        multiplier:1.20,

        boostedDomains:[

            "sleep",

            "mood",

            "bloodSugar"

        ]

    },


    "Perimenopause":{

        multiplier:1.10,

        boostedDomains:[

            "sleep",

            "mood"

        ]

    },


    "Menopause":{

        multiplier:1.10,

        boostedDomains:[

            "sleep",

            "mood"

        ]

    }

},


/*==============================================================================*
*LIFE-STAGE REFERENCE FILTER
*
*Determines whether a reference can be displayed for the user's Life Stage.
*==============================================================================*/

lifeStageReferenceRules:{


    generalAdultReferenceAllowed:[

        "Reproductive Years",

        "Planning Pregnancy",

        "Postpartum",

        "Perimenopause",

        "Menopause"

    ],


    pregnancySpecificReferenceRequired:[

        "Pregnant"

    ],


    pregnancyAdultReferenceExceptions:[

        "ada_sleep_health",

        "ada_psychosocial_wellbeing"

    ]

},


/*==============================================================================*
*LIFE-STAGE NON-INFERENCE RULES
*
*Always active.
*==============================================================================*/

lifeStageNonInferenceRules:[

    "Life Stage is context, not proof of causation.",

    "Do not infer symptoms that were not recorded.",

    "Do not infer hormonal status from today's W005 entries.",

    "Do not infer pregnancy complications.",

    "Do not infer postpartum mental-health conditions.",

    "Do not attribute glucose changes to menopause or perimenopause.",

    "Do not attribute mood changes to menopause, perimenopause, pregnancy or postpartum status.",

    "Do not attribute sleep changes to Life Stage unless merely describing a scientifically recognized context without claiming causation.",

    "Do not recommend hormone therapy.",

    "Do not recommend starting, stopping or changing prescription medicines.",

    "Do not recommend supplements based solely on Life Stage."

],


/*==============================================================================*
*SECTION C END
*
*SECTION D WILL CONTINUE INSIDE THIS SAME ROOT OBJECT.
*
*DO NOT CLOSE TRESTLE_W007_INSIGHT_DATA YET.
*==============================================================================*/
/*==============================================================================*
*DIABETES PROFILE RULES
*
*Diabetes Profile provides HEALTH CONTEXT.
*
*It does NOT automatically create a conclusion about today's readings.
*
*W007 may use Diabetes Profile to:
*
*1. Select safer glucose wording.
*2. Prioritize appropriate doctor questions.
*3. Restrict generic targets.
*4. Apply pregnancy-specific caution.
*5. Decide which scientific references are appropriate.
*
*W007 must NEVER use Diabetes Profile to independently diagnose,
*change medicines, change insulin or prescribe treatment.
*==============================================================================*/

diabetesProfileRules:{


/*==============================================================================*
*PREDIABETES
*==============================================================================*/

"Prediabetes":{

    id:"diabetes_profile_prediabetes",

    label:"Prediabetes",

    safetyMode:"PREDIABETES_CAUTION",

    glucoseMode:"OBSERVATIONAL",

    medicationMode:"NO_TREATMENT_INTERPRETATION",

    priorityDomains:[

        "movement",

        "sleep",

        "meal",

        "bloodSugar",

        "stress"

    ],


    allowedReferenceDomains:[

        "movement",

        "sleep",

        "meal",

        "stress",

        "general",

        "bloodSugar"

    ],


    contextVariants:[

        "Your Prediabetes profile gives TRESTLE metabolic context, while today's Insight remains based only on what you chose to record.",

        "Because your profile includes Prediabetes, TRESTLE can give glucose and lifestyle observations additional context without grading a single day's readings.",

        "Prediabetes makes sustainable health behaviours worth noticing, but one day's TRESTLE entries cannot establish whether your metabolic health has improved or worsened."

    ],


    doctorQuestionPreference:[

        "bloodSugar",

        "movement",

        "sleep"

    ],


    prohibitedClaims:[

        "Your prediabetes improved today.",

        "Your prediabetes worsened today.",

        "This reading confirms diabetes.",

        "This reading proves your prediabetes is controlled.",

        "A particular meal caused progression to diabetes.",

        "You should start medication.",

        "You should stop medication."

    ]

},


/*==============================================================================*
*TYPE 1 DIABETES
*==============================================================================*/

"Type 1 Diabetes":{

    id:"diabetes_profile_type_1",

    label:"Type 1 Diabetes",

    safetyMode:"TYPE1_HIGH_CAUTION",

    glucoseMode:"INDIVIDUALIZED_TARGETS_ONLY",

    medicationMode:"STRICT_NO_INSULIN_ADVICE",

    priorityDomains:[

        "bloodSugar",

        "medication",

        "meal",

        "movement",

        "sleep",

        "stress"

    ],


    allowedReferenceDomains:[

        "movement",

        "sleep",

        "stress",

        "meal",

        "general",

        "bloodSugar"

    ],


    contextVariants:[

        "Because your profile includes Type 1 Diabetes, TRESTLE treats glucose and medication information cautiously and does not alter insulin or treatment decisions.",

        "With Type 1 Diabetes in your profile, glucose context can be useful to record, but your personal targets and insulin plan belong to the care plan agreed with your clinical team.",

        "TRESTLE can help organize Type 1 Diabetes-related observations, but it does not independently interpret insulin requirements or treatment effectiveness."

    ],


    doctorQuestionPreference:[

        "bloodSugar",

        "medication",

        "movement"

    ],


    prohibitedClaims:[

        "Take more insulin.",

        "Take less insulin.",

        "Skip insulin.",

        "Change insulin timing.",

        "Exercise caused your glucose to fall.",

        "Food caused your glucose to rise.",

        "Your insulin worked.",

        "Your insulin did not work.",

        "This reading means your Type 1 Diabetes is controlled.",

        "This reading means your Type 1 Diabetes is uncontrolled."

    ]

},


/*==============================================================================*
*TYPE 2 DIABETES
*==============================================================================*/

"Type 2 Diabetes":{

    id:"diabetes_profile_type_2",

    label:"Type 2 Diabetes",

    safetyMode:"TYPE2_CAUTION",

    glucoseMode:"INDIVIDUALIZED_TARGETS_ONLY",

    medicationMode:"NO_TREATMENT_ADJUSTMENT",

    priorityDomains:[

        "bloodSugar",

        "movement",

        "meal",

        "medication",

        "sleep",

        "stress"

    ],


    allowedReferenceDomains:[

        "movement",

        "sleep",

        "stress",

        "meal",

        "general",

        "bloodSugar"

    ],


    contextVariants:[

        "Your Type 2 Diabetes profile makes glucose, movement, meal rhythm and medication useful areas of context, while TRESTLE avoids judging treatment from a single day.",

        "Because your profile includes Type 2 Diabetes, today's glucose entries can be organized and reflected back to you without substituting generic targets for your personal care plan.",

        "TRESTLE uses your Type 2 Diabetes profile to choose relevant context, not to independently classify your control or change treatment."

    ],


    doctorQuestionPreference:[

        "bloodSugar",

        "medication",

        "sleep"

    ],


    prohibitedClaims:[

        "Your diabetes is controlled.",

        "Your diabetes is uncontrolled.",

        "Your medication needs increasing.",

        "Your medication needs reducing.",

        "Your meal caused this glucose reading.",

        "Your exercise caused this glucose reading.",

        "Your stress caused this glucose reading.",

        "Your sleep caused this glucose reading."

    ]

},


/*==============================================================================*
*GESTATIONAL DIABETES
*==============================================================================*/

"Gestational Diabetes":{

    id:"diabetes_profile_gestational",

    label:"Gestational Diabetes",

    safetyMode:"GESTATIONAL_DIABETES_SAFETY",

    glucoseMode:"PREGNANCY_CLINICIAN_TARGETS",

    medicationMode:"STRICT_PREGNANCY_NO_TREATMENT_ADVICE",

    priorityDomains:[

        "bloodSugar",

        "medication",

        "meal",

        "sleep",

        "stress",

        "movement"

    ],


    allowedReferenceDomains:[

        "sleep",

        "stress",

        "bloodSugar",

        "general"

    ],


    restrictedReferenceDomains:[

        "generic_adult_glucose_target",

        "generic_adult_exercise_target",

        "generic_weight_target"

    ],


    contextVariants:[

        "Because your profile includes Gestational Diabetes, TRESTLE treats glucose information as pregnancy-specific context and leaves personal targets to your obstetric or diabetes care team.",

        "Gestational Diabetes activates TRESTLE's pregnancy glucose safety rules. Your readings are reflected factually rather than graded against a generic adult target.",

        "During Gestational Diabetes, glucose monitoring can be important, but TRESTLE does not replace the targets or treatment plan agreed with your pregnancy care team."

    ],


    doctorQuestionPreference:[

        "bloodSugar",

        "medication",

        "meal"

    ],


    doctorQuestionThreshold:"LOWER_FOR_RECURRING_RELEVANT_PATTERNS",


    prohibitedClaims:[

        "Your gestational diabetes is controlled.",

        "Your gestational diabetes is uncontrolled.",

        "This reading is safe for your pregnancy.",

        "This reading is unsafe for your pregnancy.",

        "Change insulin.",

        "Change medication.",

        "Skip medication.",

        "Change your meal plan.",

        "Exercise more to lower this reading.",

        "This food caused your glucose result."

    ]

},


/*==============================================================================*
*PREVIOUS GESTATIONAL DIABETES
*==============================================================================*/

"Previous Gestational Diabetes":{

    id:"diabetes_profile_previous_gestational",

    label:"Previous Gestational Diabetes",

    safetyMode:"POST_GDM_CAUTION",

    glucoseMode:"OBSERVATIONAL",

    medicationMode:"NO_TREATMENT_INTERPRETATION",

    priorityDomains:[

        "movement",

        "sleep",

        "meal",

        "bloodSugar",

        "stress"

    ],


    allowedReferenceDomains:[

        "movement",

        "sleep",

        "stress",

        "meal",

        "general",

        "bloodSugar"

    ],


    contextVariants:[

        "Your history of Gestational Diabetes provides useful metabolic context, but it does not mean a current glucose reading represents diabetes.",

        "Because your profile includes Previous Gestational Diabetes, sustainable lifestyle patterns and appropriately monitored glucose may be useful to notice without making a current diagnosis.",

        "A previous history of Gestational Diabetes adds context to today's reflection, while TRESTLE avoids assuming that the condition is still present."

    ],


    doctorQuestionPreference:[

        "bloodSugar",

        "movement",

        "sleep"

    ],


    prohibitedClaims:[

        "You currently have gestational diabetes.",

        "You currently have Type 2 Diabetes.",

        "This reading proves diabetes.",

        "Your previous Gestational Diabetes caused today's glucose reading.",

        "You need medication because of your previous Gestational Diabetes."

    ]

},


/*==============================================================================*
*NOT SURE
*==============================================================================*/

"Not Sure":{

    id:"diabetes_profile_not_sure",

    label:"Not Sure",

    safetyMode:"UNKNOWN_DIABETES_STATUS",

    glucoseMode:"MAXIMUM_CAUTION",

    medicationMode:"NO_DIABETES_TREATMENT_ASSUMPTION",

    priorityDomains:[

        "movement",

        "sleep",

        "stress",

        "meal",

        "bloodSugar"

    ],


    allowedReferenceDomains:[

        "movement",

        "sleep",

        "stress",

        "meal",

        "general"

    ],


    restrictedReferenceDomains:[

        "condition_specific_glucose_target",

        "condition_specific_medication",

        "condition_specific_treatment"

    ],


    contextVariants:[

        "Because your diabetes status is marked Not Sure, TRESTLE keeps glucose interpretation deliberately conservative.",

        "Your profile does not identify a confirmed diabetes type, so today's Insight avoids condition-specific glucose or treatment conclusions.",

        "With Not Sure selected for your diabetes profile, TRESTLE can reflect what you recorded while avoiding assumptions about diagnosis or personal glucose targets."

    ],


    doctorQuestionPreference:[

        "bloodSugar"

    ],


    prohibitedClaims:[

        "You have diabetes.",

        "You have prediabetes.",

        "You do not have diabetes.",

        "This reading confirms diabetes.",

        "You require diabetes medication.",

        "Your glucose target should be a specific generic number."

    ]

}

},


/*==============================================================================*
*DIABETES PROFILE DOMAIN PRIORITY
*
*Secondary modifier after Promise and Life Stage.
*==============================================================================*/

diabetesProfileDomainPriority:{


    "Prediabetes":{

        movement:95,

        sleep:90,

        meal:85,

        bloodSugar:80,

        stress:70,

        medication:45,

        mood:45,

        water:40

    },


    "Type 1 Diabetes":{

        bloodSugar:110,

        medication:110,

        meal:90,

        movement:85,

        sleep:80,

        stress:75,

        mood:45,

        water:35

    },


    "Type 2 Diabetes":{

        bloodSugar:105,

        movement:95,

        meal:90,

        medication:90,

        sleep:85,

        stress:75,

        mood:45,

        water:40

    },


    "Gestational Diabetes":{

        bloodSugar:120,

        medication:115,

        meal:100,

        sleep:85,

        stress:80,

        movement:70,

        mood:50,

        water:40

    },


    "Previous Gestational Diabetes":{

        movement:95,

        sleep:90,

        meal:85,

        bloodSugar:85,

        stress:70,

        mood:45,

        water:40,

        medication:35

    },


    "Not Sure":{

        movement:90,

        sleep:85,

        stress:75,

        meal:75,

        bloodSugar:65,

        mood:50,

        water:40,

        medication:20

    }

},


/*==============================================================================*
*DIABETES SAFETY MODES
*==============================================================================*/

diabetesSafetyModes:{


    PREDIABETES_CAUTION:{

        id:"PREDIABETES_CAUTION",

        allowGlucoseFacts:true,

        allowRelativeGlucoseComparison:true,

        allowGenericGlucoseGrading:false,

        allowDiagnosis:false,

        allowMedicationAdvice:false,

        allowTreatmentAdvice:false

    },


    TYPE1_HIGH_CAUTION:{

        id:"TYPE1_HIGH_CAUTION",

        allowGlucoseFacts:true,

        allowRelativeGlucoseComparison:true,

        allowGenericGlucoseGrading:false,

        allowInsulinAdvice:false,

        allowMedicationAdvice:false,

        allowExerciseGlucoseCausation:false,

        allowMealGlucoseCausation:false,

        allowDiagnosis:false,

        allowTreatmentAdvice:false

    },


    TYPE2_CAUTION:{

        id:"TYPE2_CAUTION",

        allowGlucoseFacts:true,

        allowRelativeGlucoseComparison:true,

        allowGenericGlucoseGrading:false,

        allowMedicationAdvice:false,

        allowExerciseGlucoseCausation:false,

        allowMealGlucoseCausation:false,

        allowStressGlucoseCausation:false,

        allowSleepGlucoseCausation:false,

        allowDiagnosis:false,

        allowTreatmentAdvice:false

    },


    GESTATIONAL_DIABETES_SAFETY:{

        id:"GESTATIONAL_DIABETES_SAFETY",

        allowGlucoseFacts:true,

        allowRelativeGlucoseComparison:true,

        allowGenericGlucoseGrading:false,

        requirePregnancyClinicalContext:true,

        allowMedicationAdvice:false,

        allowExercisePrescription:false,

        allowMealPrescription:false,

        allowDiagnosis:false,

        allowTreatmentAdvice:false,

        increaseDoctorQuestionPriority:true

    },


    POST_GDM_CAUTION:{

        id:"POST_GDM_CAUTION",

        allowGlucoseFacts:true,

        allowRelativeGlucoseComparison:true,

        allowGenericGlucoseGrading:false,

        allowCurrentDiabetesAssumption:false,

        allowMedicationAdvice:false,

        allowDiagnosis:false,

        allowTreatmentAdvice:false

    },


    UNKNOWN_DIABETES_STATUS:{

        id:"UNKNOWN_DIABETES_STATUS",

        allowGlucoseFacts:true,

        allowRelativeGlucoseComparison:true,

        allowGenericGlucoseGrading:false,

        allowConditionSpecificInterpretation:false,

        allowMedicationAssumption:false,

        allowDiagnosis:false,

        allowTreatmentAdvice:false

    }

},


/*==============================================================================*
*GLUCOSE OBSERVATION RULES
*
*These define what W007 may derive from blood sugar entries.
*
*They deliberately avoid medical grading.
*==============================================================================*/

glucoseObservationRules:{


    oneReading:{

        id:"glucose_one_reading",

        minimumReadings:1,

        pattern:"glucose_reading_recorded",

        evidenceClass:"A",

        allowed:true

    },


    multipleReadings:{

        id:"glucose_multiple_readings",

        minimumReadings:2,

        pattern:"multiple_glucose_readings",

        evidenceClass:"B",

        allowed:true

    },


    multipleContexts:{

        id:"glucose_multiple_contexts",

        minimumDistinctContexts:2,

        pattern:"glucose_readings_at_different_contexts",

        evidenceClass:"B",

        allowed:true

    },


    relativeComparison:{

        id:"glucose_relative_comparison",

        minimumReadings:2,

        pattern:"contextual_glucose_comparison_available",

        evidenceClass:"B",

        allowed:true,

        allowedLanguage:[

            "higher than the earlier reading",

            "lower than the earlier reading",

            "similar to the earlier reading"

        ],

        prohibitedLanguage:[

            "good",

            "bad",

            "safe",

            "unsafe",

            "controlled",

            "uncontrolled",

            "spike caused by",

            "drop caused by"

        ]

    }

},


/*==============================================================================*
*GLUCOSE CONTEXT LABELS
*==============================================================================*/

glucoseContexts:[

    "Fasting",

    "Before Meal",

    "After Meal",

    "Random",

    "Bedtime"

],


/*==============================================================================*
*GLUCOSE NON-INFERENCE RULES
*==============================================================================*/

glucoseNonInferenceRules:[

    "A single glucose reading must not be used to diagnose diabetes.",

    "W007 must not label a glucose reading good or bad.",

    "W007 must not label diabetes controlled or uncontrolled from W005.",

    "W007 may compare recorded readings with each other factually.",

    "W007 must not claim a meal caused a glucose change.",

    "W007 must not claim movement caused a glucose change.",

    "W007 must not claim stress caused a glucose change.",

    "W007 must not claim sleep caused a glucose change.",

    "W007 must not infer medication effectiveness from a glucose reading.",

    "W007 must not recommend medication or insulin adjustments.",

    "Pregnancy-related glucose interpretation must defer to the obstetric or diabetes care plan.",

    "If diabetes status is Not Sure, W007 must not use condition-specific target language."

],


/*==============================================================================*
*MEDICATION OBSERVATION RULES
*==============================================================================*/

medicationObservationRules:{


    taken:{

        id:"medication_taken",

        status:"Taken",

        pattern:"medication_taken",

        evidenceClass:"A",

        allowedTextVariants:[

            "You recorded your medication as taken today.",

            "Your medication check-in was marked Taken."

        ],

        priority:55,

        active:true

    },


    missed:{

        id:"medication_missed",

        status:"Missed",

        pattern:"medication_missed",

        evidenceClass:"A",

        allowedTextVariants:[

            "You recorded a missed medication today.",

            "Your medication check-in was marked Missed."

        ],

        priority:95,

        doctorQuestionEligible:true,

        active:true

    },


    notApplicable:{

        id:"medication_not_applicable",

        status:"Not Applicable",

        pattern:"medication_not_applicable",

        evidenceClass:"A",

        allowedTextVariants:[

            "You marked medication as Not Applicable today."

        ],

        priority:10,

        doctorQuestionEligible:false,

        active:true

    }

},


/*==============================================================================*
*MEDICATION SAFETY RULES
*==============================================================================*/

medicationSafetyRules:[

    "Never tell the user to take a missed dose.",

    "Never tell the user to skip a dose.",

    "Never tell the user to double a dose.",

    "Never recommend changing medication timing.",

    "Never recommend changing insulin.",

    "Never interpret treatment effectiveness from one day's entries.",

    "A missed medication entry may generate a question for a doctor or pharmacist, but TRESTLE must not answer the treatment question itself.",

    "Medication notes are user-entered context and must not be converted into a diagnosis."

],


/*==============================================================================*
*DIABETES PROFILE DOCTOR-QUESTION MODIFIERS
*==============================================================================*/

diabetesProfileDoctorQuestionModifiers:{


    "Prediabetes":{

        multiplier:1.05,

        boostedDomains:[

            "bloodSugar"

        ]

    },


    "Type 1 Diabetes":{

        multiplier:1.30,

        boostedDomains:[

            "bloodSugar",

            "medication"

        ]

    },


    "Type 2 Diabetes":{

        multiplier:1.20,

        boostedDomains:[

            "bloodSugar",

            "medication"

        ]

    },


    "Gestational Diabetes":{

        multiplier:1.40,

        boostedDomains:[

            "bloodSugar",

            "medication",

            "meal"

        ]

    },


    "Previous Gestational Diabetes":{

        multiplier:1.10,

        boostedDomains:[

            "bloodSugar"

        ]

    },


    "Not Sure":{

        multiplier:1.10,

        boostedDomains:[

            "bloodSugar"

        ]

    }

},


/*==============================================================================*
*DIABETES PROFILE REFERENCE FILTERS
*==============================================================================*/

diabetesProfileReferenceRules:{


    allowAdaIndividualizedGlucoseReference:[

        "Prediabetes",

        "Type 1 Diabetes",

        "Type 2 Diabetes",

        "Previous Gestational Diabetes",

        "Not Sure"

    ],


    requirePregnancyGlucoseReference:[

        "Gestational Diabetes"

    ],


    blockGenericGlucoseTargets:[

        "Prediabetes",

        "Type 1 Diabetes",

        "Type 2 Diabetes",

        "Gestational Diabetes",

        "Previous Gestational Diabetes",

        "Not Sure"

    ],


    allowGeneralLifestyleReferences:[

        "Prediabetes",

        "Type 1 Diabetes",

        "Type 2 Diabetes",

        "Previous Gestational Diabetes",

        "Not Sure"

    ]

},


/*==============================================================================*
*PROFILE COMBINATION SAFETY
*
*Handles combinations of Life Stage + Diabetes Profile.
*==============================================================================*/

profileCombinationSafety:{


    pregnantWithGestationalDiabetes:{

        lifeStage:"Pregnant",

        diabetesProfile:"Gestational Diabetes",

        safetyMode:"MAXIMUM_PREGNANCY_DIABETES_CAUTION",

        requirements:[

            "Use pregnancy-specific glucose context.",

            "Do not use generic nonpregnancy glucose targets.",

            "Do not recommend medication changes.",

            "Do not recommend insulin changes.",

            "Do not prescribe diet.",

            "Do not prescribe exercise.",

            "Prefer clinician questions when recurring glucose or medication concerns are recorded."

        ]

    },


    pregnantWithType1:{

        lifeStage:"Pregnant",

        diabetesProfile:"Type 1 Diabetes",

        safetyMode:"MAXIMUM_PREGNANCY_DIABETES_CAUTION",

        requirements:[

            "Use pregnancy-specific clinical context.",

            "Do not interpret insulin needs.",

            "Do not use ordinary nonpregnancy targets.",

            "Do not advise treatment changes."

        ]

    },


    pregnantWithType2:{

        lifeStage:"Pregnant",

        diabetesProfile:"Type 2 Diabetes",

        safetyMode:"MAXIMUM_PREGNANCY_DIABETES_CAUTION",

        requirements:[

            "Use pregnancy-specific clinical context.",

            "Do not interpret medication effectiveness.",

            "Do not use ordinary nonpregnancy targets.",

            "Do not advise treatment changes."

        ]

    },


    planningPregnancyWithDiabetes:{

        lifeStage:"Planning Pregnancy",

        diabetesProfileAny:[

            "Type 1 Diabetes",

            "Type 2 Diabetes",

            "Prediabetes"

        ],

        safetyMode:"PRECONCEPTION_DIABETES_CAUTION",

        requirements:[

            "Do not alter medicines.",

            "Do not recommend supplements.",

            "Do not create fertility claims.",

            "Allow appropriate doctor-question preparation."

        ]

    }

},


/*==============================================================================*
*DIABETES PROFILE NON-INFERENCE RULES
*
*Always active.
*==============================================================================*/

diabetesProfileNonInferenceRules:[

    "Diabetes Profile is context, not proof of today's metabolic state.",

    "Do not diagnose from W005 glucose entries.",

    "Do not infer diabetes control from one day.",

    "Do not infer treatment effectiveness from one day.",

    "Do not infer insulin adequacy.",

    "Do not infer medication adequacy.",

    "Do not assign generic glucose targets as personal targets.",

    "Do not interpret pregnancy glucose without pregnancy-specific clinical context.",

    "Do not assume Previous Gestational Diabetes means current diabetes.",

    "Do not assume Not Sure means diabetes is absent.",

    "Do not recommend starting, stopping or changing diabetes medication.",

    "Do not recommend insulin dose or timing changes."

],


/*==============================================================================*
*SECTION D END
*
*SECTION E WILL CONTINUE INSIDE THIS SAME ROOT OBJECT.
*
*DO NOT CLOSE TRESTLE_W007_INSIGHT_DATA YET.
*==============================================================================*/
/*==============================================================================*
*W005 DERIVED PATTERN RULES
*
*This section converts W005 daily data into safe factual or calculated patterns
*that the W007 composer may later use.
*
*Important:
*
*1. Missing data = unknown.
*2. These are observations, not diagnoses.
*3. Calculated patterns must be based only on recorded data.
*4. No causal interpretation is created here.
*==============================================================================*/

derivedPatternRules:{


/*==============================================================================*
*SLEEP PATTERNS
*==============================================================================*/

sleep:{


    recorded:{

        id:"sleep_recorded",

        domain:"sleep",

        evidenceClass:"A",

        condition:"sleep entry exists",

        priority:60,

        active:true

    },


    clearlyShorter:{

        id:"clearly_shorter_sleep",

        domain:"sleep",

        evidenceClass:"B",

        condition:{

            hoursLessThan:6

        },

        allowedTextVariants:[

            "You recorded less than 6 hours of sleep.",

            "Your recorded sleep duration was under 6 hours."

        ],

        priority:100,

        active:true

    },


    shorter:{

        id:"shorter_sleep",

        domain:"sleep",

        evidenceClass:"B",

        condition:{

            minimumHours:6,

            maximumExclusiveHours:7

        },

        allowedTextVariants:[

            "You recorded between 6 and 7 hours of sleep.",

            "Your recorded sleep duration was shorter than the commonly used 7–9 hour adult reference."

        ],

        priority:85,

        active:true

    },


    adultReferenceMet:{

        id:"adult_sleep_reference_met",

        domain:"sleep",

        evidenceClass:"B",

        condition:{

            minimumHours:7,

            maximumHours:9

        },

        allowedTextVariants:[

            "Your recorded sleep duration sat within the commonly used 7–9 hour adult reference range.",

            "The sleep duration you recorded was within a commonly used general adult reference range."

        ],

        priority:80,

        active:true

    },


    longer:{

        id:"longer_sleep_recorded",

        domain:"sleep",

        evidenceClass:"B",

        condition:{

            hoursGreaterThan:9

        },

        allowedTextVariants:[

            "You recorded more than 9 hours of sleep.",

            "Your recorded sleep duration was longer than the commonly used 7–9 hour adult reference."

        ],

        priority:45,

        active:true

    },


    qualityGood:{

        id:"sleep_quality_good",

        domain:"sleep",

        evidenceClass:"A",

        condition:{

            quality:"Good"

        },

        priority:85,

        active:true

    },


    qualityAverage:{

        id:"sleep_quality_average",

        domain:"sleep",

        evidenceClass:"A",

        condition:{

            quality:"Average"

        },

        priority:45,

        active:true

    },


    qualityPoor:{

        id:"sleep_quality_poor",

        domain:"sleep",

        evidenceClass:"A",

        condition:{

            quality:"Poor"

        },

        priority:95,

        active:true

    }

},


/*==============================================================================*
*STRESS PATTERNS
*==============================================================================*/

stress:{


    recorded:{

        id:"stress_recorded",

        domain:"stress",

        evidenceClass:"A",

        condition:"stress entry exists",

        priority:55,

        active:true

    },


    low:{

        id:"stress_low",

        domain:"stress",

        evidenceClass:"A",

        condition:{

            level:"Low"

        },

        priority:80,

        active:true

    },


    moderate:{

        id:"stress_moderate",

        domain:"stress",

        evidenceClass:"A",

        condition:{

            level:"Moderate"

        },

        priority:55,

        active:true

    },


    high:{

        id:"stress_high",

        domain:"stress",

        evidenceClass:"A",

        condition:{

            level:"High"

        },

        priority:95,

        active:true

    }

},


/*==============================================================================*
*MOOD PATTERNS
*==============================================================================*/

mood:{


    recorded:{

        id:"mood_recorded",

        domain:"mood",

        evidenceClass:"A",

        condition:"mood entry exists",

        priority:50,

        active:true

    },


    good:{

        id:"mood_good",

        domain:"mood",

        evidenceClass:"A",

        condition:{

            mood:"Good"

        },

        priority:70,

        active:true

    },


    okay:{

        id:"mood_okay",

        domain:"mood",

        evidenceClass:"A",

        condition:{

            mood:"Okay"

        },

        priority:45,

        active:true

    },


    low:{

        id:"mood_low",

        domain:"mood",

        evidenceClass:"A",

        condition:{

            mood:"Low"

        },

        priority:70,

        active:true

    }

},


/*==============================================================================*
*MOVEMENT PATTERNS
*==============================================================================*/

movement:{


    recorded:{

        id:"movement_recorded",

        domain:"movement",

        evidenceClass:"A",

        condition:"one or more movement entries exist",

        priority:85,

        active:true

    },


    multipleSessions:{

        id:"multiple_movement_sessions",

        domain:"movement",

        evidenceClass:"B",

        condition:{

            minimumSessions:2

        },

        priority:95,

        active:true

    },


    totalMinutes:{

        id:"movement_total_minutes",

        domain:"movement",

        evidenceClass:"B",

        calculation:

            "Sum movement minutes from all movement entries for the day.",

        priority:80,

        active:true

    },


    walkingRecorded:{

        id:"walking_recorded",

        domain:"movement",

        evidenceClass:"A",

        condition:{

            activity:"Walking"

        },

        priority:60,

        active:true

    },


    exerciseRecorded:{

        id:"exercise_recorded",

        domain:"movement",

        evidenceClass:"A",

        condition:{

            activity:"Exercise"

        },

        priority:60,

        active:true

    },


    yogaRecorded:{

        id:"yoga_recorded",

        domain:"movement",

        evidenceClass:"A",

        condition:{

            activity:"Yoga"

        },

        priority:60,

        active:true

    },


    otherActivityRecorded:{

        id:"other_activity_recorded",

        domain:"movement",

        evidenceClass:"A",

        condition:{

            activity:"Other"

        },

        priority:50,

        active:true

    }

},


/*==============================================================================*
*MEAL PATTERNS
*==============================================================================*/

meal:{


    recorded:{

        id:"meal_recorded",

        domain:"meal",

        evidenceClass:"A",

        condition:"one or more meal entries exist",

        priority:55,

        active:true

    },


    breakfastRecorded:{

        id:"breakfast_recorded",

        domain:"meal",

        evidenceClass:"A",

        condition:{

            mealType:"Breakfast"

        },

        priority:55,

        active:true

    },


    lunchRecorded:{

        id:"lunch_recorded",

        domain:"meal",

        evidenceClass:"A",

        condition:{

            mealType:"Lunch"

        },

        priority:55,

        active:true

    },


    dinnerRecorded:{

        id:"dinner_recorded",

        domain:"meal",

        evidenceClass:"A",

        condition:{

            mealType:"Dinner"

        },

        priority:55,

        active:true

    },


    snackRecorded:{

        id:"snack_recorded",

        domain:"meal",

        evidenceClass:"A",

        condition:{

            mealType:"Snack"

        },

        priority:35,

        active:true

    },


    mealCount:{

        id:"meal_count",

        domain:"meal",

        evidenceClass:"B",

        calculation:

            "Count all meal entries recorded for the day.",

        priority:45,

        active:true

    },


    sequenceAvailable:{

        id:"meal_sequence_available",

        domain:"meal",

        evidenceClass:"B",

        condition:{

            minimumTimedMeals:2

        },

        priority:65,

        active:true

    },


    firstMealTime:{

        id:"first_recorded_meal_time",

        domain:"meal",

        evidenceClass:"B",

        calculation:

            "Find the earliest valid meal eventTime recorded for the day.",

        priority:45,

        active:true

    },


    lastMealTime:{

        id:"last_recorded_meal_time",

        domain:"meal",

        evidenceClass:"B",

        calculation:

            "Find the latest valid meal eventTime recorded for the day.",

        priority:45,

        active:true

    },


    breakfastLunchInterval:{

        id:"breakfast_to_lunch_interval",

        domain:"meal",

        evidenceClass:"B",

        condition:{

            requires:[

                "breakfast_recorded",

                "lunch_recorded"

            ]

        },

        calculation:

            "Calculate time difference between the latest valid Breakfast event before the selected Lunch and that Lunch event.",

        priority:70,

        active:true

    },


    lunchDinnerInterval:{

        id:"lunch_to_dinner_interval",

        domain:"meal",

        evidenceClass:"B",

        condition:{

            requires:[

                "lunch_recorded",

                "dinner_recorded"

            ]

        },

        calculation:

            "Calculate time difference between the latest valid Lunch event before the selected Dinner and that Dinner event.",

        priority:65,

        active:true

    },


    longRecordedMealInterval:{

        id:"long_recorded_meal_interval",

        domain:"meal",

        evidenceClass:"B",

        condition:{

            intervalMinutesGreaterThanOrEqual:330

        },

        interpretation:

            "This indicates only that two recorded main meals were at least 5 hours 30 minutes apart. It must not be described as medically too long.",

        priority:75,

        active:true

    },


    laterEveningMeal:{

        id:"later_evening_meal_recorded",

        domain:"meal",

        evidenceClass:"B",

        condition:{

            dinnerEventTimeAtOrAfter:"21:00"

        },

        interpretation:

            "Use only as a factual later-evening meal timing observation. Do not claim harm or causation.",

        priority:55,

        active:true

    },


    foodDescriptionAvailable:{

        id:"meal_description_available",

        domain:"meal",

        evidenceClass:"A",

        condition:"one or more meal entries contain non-empty food text",

        priority:30,

        active:true

    }

},


/*==============================================================================*
*WATER PATTERNS
*==============================================================================*/

water:{


    logged:{

        id:"water_logged",

        domain:"water",

        evidenceClass:"A",

        condition:"water entry exists",

        priority:40,

        active:true

    },


    glassesReported:{

        id:"water_glasses_reported",

        domain:"water",

        evidenceClass:"A",

        valueField:"glasses",

        priority:40,

        active:true

    },


    prohibitedDerivedPatterns:[

        "dehydrated",

        "adequately_hydrated",

        "hydration_target_met",

        "hydration_target_missed"

    ]

},


/*==============================================================================*
*BLOOD SUGAR PATTERNS
*==============================================================================*/

bloodSugar:{


    recorded:{

        id:"glucose_reading_recorded",

        domain:"bloodSugar",

        evidenceClass:"A",

        condition:"one or more blood sugar entries exist",

        priority:65,

        active:true

    },


    multipleReadings:{

        id:"multiple_glucose_readings",

        domain:"bloodSugar",

        evidenceClass:"B",

        condition:{

            minimumReadings:2

        },

        priority:80,

        active:true

    },


    fastingAvailable:{

        id:"fasting_reading_available",

        domain:"bloodSugar",

        evidenceClass:"A",

        condition:{

            context:"Fasting"

        },

        priority:60,

        active:true

    },


    beforeMealAvailable:{

        id:"before_meal_reading_available",

        domain:"bloodSugar",

        evidenceClass:"A",

        condition:{

            context:"Before Meal"

        },

        priority:55,

        active:true

    },


    afterMealAvailable:{

        id:"after_meal_reading_available",

        domain:"bloodSugar",

        evidenceClass:"A",

        condition:{

            context:"After Meal"

        },

        priority:60,

        active:true

    },


    randomAvailable:{

        id:"random_reading_available",

        domain:"bloodSugar",

        evidenceClass:"A",

        condition:{

            context:"Random"

        },

        priority:45,

        active:true

    },


    bedtimeAvailable:{

        id:"bedtime_reading_available",

        domain:"bloodSugar",

        evidenceClass:"A",

        condition:{

            context:"Bedtime"

        },

        priority:50,

        active:true

    },


    differentContexts:{

        id:"glucose_readings_at_different_contexts",

        domain:"bloodSugar",

        evidenceClass:"B",

        condition:{

            minimumDistinctContexts:2

        },

        priority:85,

        active:true

    },


    contextualComparisonAvailable:{

        id:"contextual_glucose_comparison_available",

        domain:"bloodSugar",

        evidenceClass:"B",

        condition:{

            minimumValidReadings:2

        },

        priority:70,

        active:true

    },


    earlierLaterComparison:{

        id:"earlier_and_later_readings_available",

        domain:"bloodSugar",

        evidenceClass:"B",

        condition:{

            minimumTimedReadings:2

        },

        priority:65,

        active:true

    },


    laterHigher:{

        id:"later_reading_higher_than_earlier",

        domain:"bloodSugar",

        evidenceClass:"B",

        calculation:

            "Compare two chronologically ordered valid readings.",

        allowedLanguage:

            "The later reading was higher than the earlier reading.",

        prohibitedLanguage:[

            "spike",

            "bad",

            "dangerous",

            "uncontrolled"

        ],

        priority:60,

        active:true

    },


    laterLower:{

        id:"later_reading_lower_than_earlier",

        domain:"bloodSugar",

        evidenceClass:"B",

        calculation:

            "Compare two chronologically ordered valid readings.",

        allowedLanguage:

            "The later reading was lower than the earlier reading.",

        prohibitedLanguage:[

            "improved because",

            "exercise lowered",

            "medicine worked"

        ],

        priority:60,

        active:true

    },


    similarReadings:{

        id:"readings_similar",

        domain:"bloodSugar",

        evidenceClass:"B",

        interpretation:

            "Similarity threshold should remain an internal technical tolerance and must not imply clinical stability.",

        priority:40,

        active:true

    },


    maximumDifference:{

        id:"largest_recorded_difference",

        domain:"bloodSugar",

        evidenceClass:"B",

        calculation:

            "Calculate the numerical difference between the highest and lowest recorded glucose values for the day.",

        interpretation:

            "May be used internally for ranking but should not automatically be displayed as a medically meaningful variation.",

        priority:45,

        active:true

    }

},


/*==============================================================================*
*MEDICATION PATTERNS
*==============================================================================*/

medication:{


    recorded:{

        id:"medication_status_recorded",

        domain:"medication",

        evidenceClass:"A",

        condition:"medication entry exists",

        priority:45,

        active:true

    },


    taken:{

        id:"medication_taken",

        domain:"medication",

        evidenceClass:"A",

        condition:{

            status:"Taken"

        },

        priority:55,

        active:true

    },


    missed:{

        id:"medication_missed",

        domain:"medication",

        evidenceClass:"A",

        condition:{

            status:"Missed"

        },

        priority:95,

        doctorQuestionEligible:true,

        active:true

    },


    notApplicable:{

        id:"medication_not_applicable",

        domain:"medication",

        evidenceClass:"A",

        condition:{

            status:"Not Applicable"

        },

        priority:10,

        active:true

    }

},


/*==============================================================================*
*MISSING DATA PATTERNS
*
*These patterns are factual states only.
*
*They must never be interpreted as failure, absence of behaviour or negative
*health status.
*==============================================================================*/

missingData:{


    bloodSugar:{

        id:"bloodSugar_not_logged",

        domain:"bloodSugar",

        meaning:"Unknown",

        prohibitedInterpretation:

            "Do not infer that blood sugar was not checked."

    },


    meal:{

        id:"meal_not_logged",

        domain:"meal",

        meaning:"Unknown",

        prohibitedInterpretation:

            "Do not infer that the user skipped meals."

    },


    medication:{

        id:"medication_not_logged",

        domain:"medication",

        meaning:"Unknown",

        prohibitedInterpretation:

            "Do not infer medication was missed."

    },


    water:{

        id:"water_not_logged",

        domain:"water",

        meaning:"Unknown",

        prohibitedInterpretation:

            "Do not infer that the user drank no water."

    },


    movement:{

        id:"movement_not_logged",

        domain:"movement",

        meaning:"Unknown",

        prohibitedInterpretation:

            "Do not infer that the user was sedentary."

    },


    mood:{

        id:"mood_not_logged",

        domain:"mood",

        meaning:"Unknown",

        prohibitedInterpretation:

            "Do not infer a negative mood."

    },


    stress:{

        id:"stress_not_logged",

        domain:"stress",

        meaning:"Unknown",

        prohibitedInterpretation:

            "Do not infer that stress was absent or high."

    },


    sleep:{

        id:"sleep_not_logged",

        domain:"sleep",

        meaning:"Unknown",

        prohibitedInterpretation:

            "Do not infer poor sleep or adequate sleep."

    }

},


/*==============================================================================*
*CROSS-PATTERN OBSERVATIONS
*
*These are allowed co-occurrences.
*
*They may be mentioned cautiously.
*
*They NEVER establish causation.
*==============================================================================*/

crossPatterns:{


    shortSleepHighStress:{

        id:"short_sleep_high_stress",

        domains:[

            "sleep",

            "stress"

        ],

        requiresAnySleep:[

            "clearly_shorter_sleep",

            "shorter_sleep",

            "sleep_quality_poor"

        ],

        requires:[

            "stress_high"

        ],

        evidenceClass:"C",

        allowedTextVariants:[

            "Shorter or poorer-rated sleep appeared alongside a high-stress day in what you recorded.",

            "You recorded less favourable sleep and also described the day as high stress."

        ],

        requiredQualifier:

            "One day does not establish that these are connected.",

        priority:95,

        active:true

    },


    shortSleepLowMood:{

        id:"short_sleep_low_mood",

        domains:[

            "sleep",

            "mood"

        ],

        requiresAnySleep:[

            "clearly_shorter_sleep",

            "shorter_sleep",

            "sleep_quality_poor"

        ],

        requires:[

            "mood_low"

        ],

        evidenceClass:"C",

        allowedTextVariants:[

            "Less favourable sleep and a low mood appeared together in today's check-ins.",

            "You recorded shorter or poorer-rated sleep alongside a low mood."

        ],

        requiredQualifier:

            "This is only a co-occurrence in today's entries, not evidence that one caused the other.",

        priority:80,

        active:true

    },


    highStressLowMood:{

        id:"high_stress_low_mood",

        domains:[

            "stress",

            "mood"

        ],

        requires:[

            "stress_high",

            "mood_low"

        ],

        evidenceClass:"C",

        allowedTextVariants:[

            "You described both stress and mood less favourably today.",

            "High stress and a low mood were both present in the check-ins you recorded."

        ],

        requiredQualifier:

            "These entries do not establish a mental-health diagnosis or a causal relationship.",

        priority:85,

        active:true

    },


    movementWithHighStress:{

        id:"movement_with_high_stress",

        domains:[

            "movement",

            "stress"

        ],

        requires:[

            "movement_recorded",

            "stress_high"

        ],

        evidenceClass:"C",

        allowedTextVariants:[

            "Even on a day you described as high stress, you still made some room for movement.",

            "You recorded movement despite describing the day as stressful."

        ],

        priority:90,

        preferredSection:"promise_or_positive",

        active:true

    },


    movementWithLowMood:{

        id:"movement_with_low_mood",

        domains:[

            "movement",

            "mood"

        ],

        requires:[

            "movement_recorded",

            "mood_low"

        ],

        evidenceClass:"C",

        allowedTextVariants:[

            "Even while describing your mood as low, you still made some room for movement.",

            "Movement was one positive behaviour you recorded on a day when your mood was low."

        ],

        priority:85,

        preferredSection:"promise_or_positive",

        active:true

    },


    goodSleepLowStress:{

        id:"good_sleep_low_stress",

        domains:[

            "sleep",

            "stress"

        ],

        requires:[

            "sleep_quality_good",

            "stress_low"

        ],

        evidenceClass:"C",

        allowedTextVariants:[

            "You recorded good-quality sleep and described today's stress as low.",

            "Good-rated sleep and lower stress both appeared in today's check-ins."

        ],

        requiredQualifier:

            "TRESTLE does not assume one produced the other.",

        priority:75,

        preferredSection:"promise_or_positive",

        active:true

    },


    goodMoodHighStress:{

        id:"good_mood_high_stress",

        domains:[

            "mood",

            "stress"

        ],

        requires:[

            "mood_good",

            "stress_high"

        ],

        evidenceClass:"C",

        allowedTextVariants:[

            "You described the day as stressful while still rating your mood as good.",

            "High stress and a good mood appeared together in your check-ins; both can be true at the same time."

        ],

        priority:80,

        preferredSection:"day_observation",

        active:true

    }

},


/*==============================================================================*
*PROHIBITED CROSS-INFERENCES
*
*These combinations may coexist in the data but must not be converted into
*causal conclusions.
*==============================================================================*/

prohibitedCrossInferences:[

    "sleep → glucose causation",

    "stress → glucose causation",

    "meal → glucose causation",

    "movement → glucose causation",

    "medication → glucose causation",

    "sleep → mood causation",

    "stress → mood causation",

    "movement → mood causation",

    "meal timing → energy causation",

    "sleep → focus causation",

    "stress → focus causation",

    "life stage → glucose causation",

    "life stage → mood causation",

    "life stage → sleep causation",

    "life stage → stress causation"

],


/*==============================================================================*
*DERIVED DATA QUALITY RULES
*
*Used to determine how much of W007 can be generated.
*==============================================================================*/

dataCoverageRules:{


    zeroCheckins:{

        minimum:0,

        maximum:0,

        level:"NONE",

        allowFullInsight:false,

        allowScienceSection:false,

        allowDoctorQuestions:false

    },


    oneCheckin:{

        minimum:1,

        maximum:1,

        level:"VERY_LIGHT",

        allowFullInsight:false,

        allowScienceSection:"ONLY_IF_DIRECTLY_RELEVANT",

        allowDoctorQuestions:"ONLY_IF_STRONG_TRIGGER"

    },


    twoToThreeCheckins:{

        minimum:2,

        maximum:3,

        level:"LIGHT",

        allowFullInsight:false,

        allowScienceSection:true,

        allowDoctorQuestions:"ONLY_IF_SUPPORTED"

    },


    fourOrMoreCheckins:{

        minimum:4,

        maximum:null,

        level:"FULL",

        allowFullInsight:true,

        allowScienceSection:true,

        allowDoctorQuestions:"IF_SUPPORTED"

    }

},


/*==============================================================================*
*DERIVED PATTERN OUTPUT LIMITS
*==============================================================================*/

derivedPatternOutputRules:{

    maximumCrossPatternsPerInsight:2,

    maximumMealTimingObservations:1,

    maximumGlucoseComparisonObservations:1,

    maximumPositivePatterns:2,

    maximumAttentionPatterns:1,

    preferDirectFactsOverWeakCrossPatterns:true,

    preferPromiseRelevantPattern:true,

    doNotMentionMissingDataAsNegative:true,

    doNotCreateHealthScore:true,

    doNotCreateDailySuccessPercentage:true

},

},


/*==============================================================================*
*SECTION E END
*
*SECTION F WILL CONTINUE INSIDE THIS SAME ROOT OBJECT.
*
*DO NOT CLOSE TRESTLE_W007_INSIGHT_DATA YET.
*==============================================================================*/
/*==============================================================================*
*SCIENCE & YOUR DAY SELECTION RULES
*
*Science context must:
*
*1. Be supported by actual recorded data.
*2. Be applicable to the user's Life Stage.
*3. Be applicable to the user's Diabetes Profile.
*4. Never be presented as a personal medical target unless explicitly allowed.
*5. Never exceed the configured maximum references.
*==============================================================================*/

scienceSelectionRules:{


    maximumReferences:2,


    selectionOrder:[

        "promise_relevance",

        "life_stage_relevance",

        "diabetes_profile_relevance",

        "recorded_domain_strength",

        "reference_priority"

    ],


    domainReferenceMap:{


        sleep:[

            "adult_sleep_duration_reference",

            "ada_sleep_health"

        ],


        movement:[

            "who_adult_physical_activity",

            "ada_diabetes_physical_activity",

            "who_adult_physical_activity_additional"

        ],


        stress:[

            "ada_psychosocial_wellbeing"

        ],


        meal:[

            "who_healthy_diet_fruit_vegetables",

            "niddk_diabetes_healthy_living"

        ],


        bloodSugar:[

            "ada_individualized_glucose_goals",

            "pregnancy_glucose_individualized_care"

        ],


        general:[

            "niddk_diabetes_healthy_living"

        ]

    },


    prohibitScienceForDomains:[

        "water",

        "mood",

        "medication"

    ],


    rules:[


        {
            id:"science_sleep_when_recorded",

            domain:"sleep",

            requiresAny:[

                "sleep_recorded",

                "shorter_sleep",

                "clearly_shorter_sleep",

                "sleep_quality_poor",

                "sleep_quality_good"

            ],

            referencePreference:[

                "adult_sleep_duration_reference",

                "ada_sleep_health"

            ],

            priority:95,

            active:true
        },


        {
            id:"science_movement_when_recorded",

            domain:"movement",

            requiresAny:[

                "movement_recorded",

                "multiple_movement_sessions",

                "movement_total_minutes"

            ],

            referencePreference:[

                "who_adult_physical_activity",

                "ada_diabetes_physical_activity"

            ],

            priority:90,

            active:true
        },


        {
            id:"science_stress_when_relevant",

            domain:"stress",

            requiresAny:[

                "stress_high",

                "stress_moderate",

                "stress_low"

            ],

            referencePreference:[

                "ada_psychosocial_wellbeing"

            ],

            priority:75,

            active:true
        },


        {
            id:"science_meal_general_context",

            domain:"meal",

            requiresAny:[

                "meal_recorded",

                "meal_sequence_available"

            ],

            referencePreference:[

                "niddk_diabetes_healthy_living",

                "who_healthy_diet_fruit_vegetables"

            ],

            priority:60,

            active:true
        },


        {
            id:"science_glucose_individualized",

            domain:"bloodSugar",

            requiresAny:[

                "glucose_reading_recorded",

                "multiple_glucose_readings",

                "contextual_glucose_comparison_available"

            ],

            referencePreference:[

                "ada_individualized_glucose_goals"

            ],

            priority:85,

            active:true
        },


        {
            id:"science_pregnancy_glucose",

            domain:"bloodSugar",

            requiresAny:[

                "glucose_reading_recorded",

                "multiple_glucose_readings"

            ],

            requiresProfileAny:{

                lifeStage:[

                    "Pregnant"

                ],

                diabetesProfile:[

                    "Gestational Diabetes"

                ]

            },

            referencePreference:[

                "pregnancy_glucose_individualized_care"

            ],

            priority:120,

            active:true
        }

    ],


    displayRules:{

        maximumParagraphs:2,

        maximumReferencesPerParagraph:1,

        preferOneStrongReferenceOverTwoWeakReferences:true,

        neverRepeatSameAuthorityWithoutNeed:true,

        neverUseScienceAsDiagnosis:true,

        neverUseScienceToGradeWater:true,

        neverUseScienceToGradeMood:true,

        neverUseScienceToGradeStressNumerically:true

    }

},


/*==============================================================================*
*SCIENCE OUTPUT VARIANTS
*
*These are approved report-ready sentence families.
*==============================================================================*/

scienceOutputVariants:{


    sleepShorter:{

        domain:"sleep",

        requiresAny:[

            "shorter_sleep",

            "clearly_shorter_sleep"

        ],

        variants:[

            "Your recorded sleep was shorter than the commonly used 7–9 hour adult reference. Sleep needs vary, but sleep health is recognized as an important part of overall well-being.",

            "You recorded less sleep than the general 7–9 hour adult reference. This is context rather than a personal medical target.",

            "Your sleep duration sat below a commonly used adult reference range. TRESTLE uses this only as general context, not as a diagnosis."

        ],

        sourceIds:[

            "adult_sleep_duration_reference",

            "ada_sleep_health"

        ],

        priority:100,

        active:true

    },


    sleepWithinReference:{

        domain:"sleep",

        requires:[

            "adult_sleep_reference_met"

        ],

        variants:[

            "The sleep duration you recorded sat within a commonly used 7–9 hour adult reference range. Sleep quality still matters separately.",

            "Your recorded sleep duration was within a general adult reference range. TRESTLE treats duration and quality as separate parts of the picture."

        ],

        sourceIds:[

            "adult_sleep_duration_reference"

        ],

        priority:80,

        active:true

    },


    movementRecorded:{

        domain:"movement",

        requires:[

            "movement_recorded"

        ],

        variants:[

            "You recorded movement today. WHO recommends adults build regular physical activity across the week rather than treating one day as a pass-or-fail target.",

            "Your movement today contributes to the broader weekly pattern that WHO guidance emphasizes for adults.",

            "WHO guidance focuses on building regular physical activity across the week. Today's recorded movement is one part of that larger pattern."

        ],

        sourceIds:[

            "who_adult_physical_activity"

        ],

        priority:90,

        active:true

    },


    stressContext:{

        domain:"stress",

        requiresAny:[

            "stress_high",

            "stress_moderate"

        ],

        variants:[

            "Stress and psychosocial well-being are recognized as relevant parts of diabetes self-management and overall health behaviour. Your stress check-in is therefore useful context rather than a diagnosis.",

            "Your stress entry is worth noticing because psychosocial well-being is recognized as relevant to diabetes-related self-management. One daily check-in does not establish a clinical condition."

        ],

        sourceIds:[

            "ada_psychosocial_wellbeing"

        ],

        priority:75,

        active:true

    },


    glucoseContext:{

        domain:"bloodSugar",

        requires:[

            "glucose_reading_recorded"

        ],

        variants:[

            "Glucose goals are individualized. TRESTLE therefore reflects your readings factually rather than grading them against a generic target.",

            "Because glucose goals differ by person and clinical context, TRESTLE keeps your readings descriptive rather than labeling them good or bad."

        ],

        sourceIds:[

            "ada_individualized_glucose_goals"

        ],

        priority:85,

        active:true

    },


    pregnancyGlucoseContext:{

        domain:"bloodSugar",

        requires:[

            "glucose_reading_recorded"

        ],

        profileRequirements:{

            lifeStageAny:[

                "Pregnant"

            ],

            diabetesProfileAny:[

                "Gestational Diabetes",

                "Type 1 Diabetes",

                "Type 2 Diabetes"

            ]

        },

        variants:[

            "During pregnancy, glucose targets should follow the plan agreed with your obstetric or diabetes care team. TRESTLE therefore keeps your readings factual rather than applying a generic target.",

            "Because you are pregnant, TRESTLE does not compare your glucose readings with ordinary adult targets. Your care team's pregnancy-specific plan remains the appropriate reference."

        ],

        sourceIds:[

            "pregnancy_glucose_individualized_care"

        ],

        priority:120,

        active:true

    }

},


/*==============================================================================*
*TOMORROW FOCUS LIBRARY
*
*Exactly ONE focus may appear.
*
*Every focus must be:
*
*1. Supported by recorded data.
*2. Relevant to the Promise where possible.
*3. Low risk.
*4. Behavioural rather than medical.
*5. Non-prescriptive.
*==============================================================================*/

tomorrowFocusLibrary:{


/*==============================================================================*
*SLEEP
*==============================================================================*/

sleep_shorter_better_sleep:{

    id:"sleep_shorter_better_sleep",

    domain:"sleep",

    promises:[

        "Better Sleep",

        "More Energy",

        "Better Focus",

        "Balanced Life",

        "Healthier Living"

    ],

    requiresAny:[

        "clearly_shorter_sleep",

        "shorter_sleep"

    ],

    variants:[

        "Tonight, if your schedule allows, protect a little more opportunity for sleep.",

        "Your simplest focus for tonight is to give sleep a little more space rather than changing several parts of the day.",

        "If practical, begin winding down a little earlier tonight and notice whether that feels sustainable."

    ],

    priority:100,

    active:true

},


sleep_poor_quality:{

    id:"sleep_poor_quality",

    domain:"sleep",

    promises:[

        "Better Sleep",

        "More Energy",

        "Better Focus",

        "More Calmness",

        "Balanced Life",

        "Healthier Living"

    ],

    requires:[

        "sleep_quality_poor"

    ],

    variants:[

        "Tonight, keep the focus small: protect a calmer wind-down rather than trying to perfect your entire sleep routine.",

        "Your next focus can simply be to notice what your last hour before bed looks like tonight.",

        "Rather than changing several things, give yourself one deliberate wind-down cue before sleep tonight."

    ],

    priority:95,

    active:true

},


sleep_success_maintain:{

    id:"sleep_success_maintain",

    domain:"sleep",

    promises:[

        "Better Sleep",

        "More Energy",

        "Better Focus",

        "Balanced Life",

        "Healthier Living"

    ],

    requires:[

        "adult_sleep_reference_met",

        "sleep_quality_good"

    ],

    variants:[

        "Yesterday's sleep entry already moved in a supportive direction. Today's focus may simply be to protect whatever helped that routine work.",

        "You do not need a new sleep task today. Try repeating the routine that supported yesterday's good-rated sleep.",

        "Keep today's focus simple: protect the sleep routine that already worked yesterday."

    ],

    priority:90,

    active:true

},


/*==============================================================================*
*STRESS
*==============================================================================*/

stress_high_more_calmness:{

    id:"stress_high_more_calmness",

    domain:"stress",

    promises:[

        "More Calmness",

        "Balanced Life",

        "Better Focus",

        "Better Sleep"

    ],

    requires:[

        "stress_high"

    ],

    variants:[

        "Tomorrow, deliberately protect one short pause during the most demanding part of your workday.",

        "Your small focus tomorrow is not to make the whole day calm—just create one deliberate pause when pressure builds.",

        "Tomorrow, notice one point in the day where you can interrupt the rush for a few minutes."

    ],

    priority:100,

    active:true

},


stress_low_maintain:{

    id:"stress_low_maintain",

    domain:"stress",

    promises:[

        "More Calmness",

        "Balanced Life"

    ],

    requires:[

        "stress_low"

    ],

    variants:[

        "Yesterday's lower-stress check-in is worth protecting. Notice what felt different about the day and repeat one part of it if you can.",

        "Rather than adding a new task, try to preserve one thing from yesterday that helped the day feel manageable.",

        "Your focus can simply be to notice and repeat one part of yesterday's calmer rhythm."

    ],

    priority:80,

    active:true

},


/*==============================================================================*
*MEAL RHYTHM
*==============================================================================*/

long_meal_interval:{

    id:"long_meal_interval",

    domain:"meal",

    promises:[

        "More Energy",

        "Better Focus",

        "Balanced Life",

        "Healthier Living"

    ],

    requires:[

        "long_recorded_meal_interval"

    ],

    variants:[

        "Tomorrow, simply notice whether work is pushing your next main meal later than you intended.",

        "Your focus tomorrow is only to notice the gap between your first two main meals—no need to overhaul your eating pattern.",

        "Tomorrow, keep an eye on whether the workday stretches the interval between your main meals more than you would prefer."

    ],

    priority:85,

    active:true

},


meal_sequence_success:{

    id:"meal_sequence_success",

    domain:"meal",

    promises:[

        "Balanced Life",

        "Healthier Living",

        "More Energy",

        "Better Focus"

    ],

    requires:[

        "meal_sequence_available"

    ],

    excludes:[

        "long_recorded_meal_interval"

    ],

    variants:[

        "You recorded enough of your meal rhythm to make the day visible. Tomorrow, simply continue noticing the timing that works for you.",

        "Your meal entries already gave you a clearer picture of the day. Keep tomorrow's focus on awareness rather than changing everything.",

        "Tomorrow, repeat the simple habit of noticing when your main meals actually happen."

    ],

    priority:65,

    active:true

},


/*==============================================================================*
*MOVEMENT
*==============================================================================*/

movement_success_repeat:{

    id:"movement_success_repeat",

    domain:"movement",

    promises:[

        "Healthier Living",

        "Balanced Life",

        "More Energy",

        "More Calmness",

        "Better Focus"

    ],

    requires:[

        "movement_recorded"

    ],

    variants:[

        "Repeat one movement habit that already worked yesterday.",

        "You already made some room for movement. Tomorrow's focus can simply be to repeat one part of that.",

        "Rather than adding a new exercise goal, try to protect one movement moment that already fitted into yesterday."

    ],

    priority:85,

    active:true

},


movement_multiple_success:{

    id:"movement_multiple_success",

    domain:"movement",

    promises:[

        "Healthier Living",

        "Balanced Life",

        "More Energy"

    ],

    requires:[

        "multiple_movement_sessions"

    ],

    variants:[

        "You found more than one opportunity to move yesterday. Tomorrow, simply protect one of those opportunities again.",

        "Multiple movement moments already fitted into your day. Your next focus can be to repeat the easiest one.",

        "Yesterday shows movement can fit into your workday more than once. Tomorrow, protect whichever of those moments felt most practical."

    ],

    priority:95,

    active:true

},


/*==============================================================================*
*WATER
*==============================================================================*/

water_awareness:{

    id:"water_awareness",

    domain:"water",

    promises:[

        "Healthier Living",

        "Balanced Life"

    ],

    requires:[

        "water_logged"

    ],

    variants:[

        "Tomorrow, keep water visible and easy to reach during the workday rather than chasing a fixed number.",

        "Your hydration focus tomorrow can simply be convenience: keep water where you are likely to remember it.",

        "There is no need for a rigid glass target. Tomorrow, make water easy to notice during your workday."

    ],

    priority:45,

    active:true

},


/*==============================================================================*
*SPARSE-DATA FALLBACK
*==============================================================================*/

promise_sparse_fallback:{

    id:"promise_sparse_fallback",

    domain:"general",

    promises:[

        "Balanced Life",

        "More Energy",

        "Better Sleep",

        "More Calmness",

        "Better Focus",

        "Healthier Living"

    ],

    requiresDataLevelAny:[

        "VERY_LIGHT",

        "LIGHT"

    ],

    variants:[

        "Tomorrow, record only what feels useful. TRESTLE would rather have a few real entries than fill gaps with assumptions.",

        "Your next focus is simply awareness: record one or two parts of the day that matter most to your Promise.",

        "There is no need to complete every check-in tomorrow. Capture the parts of your day that genuinely feel relevant."

    ],

    priority:20,

    active:true

}

},


/*==============================================================================*
*TOMORROW FOCUS SELECTION RULES
*==============================================================================*/

tomorrowFocusSelectionRules:{

    maximumItems:1,

    preferPromiseMatch:true,

    preferHighestPrioritySupportedRule:true,

    preferMaintainSuccessWhenStrongPositiveExists:true,

    doNotCreateMedicalAction:true,

    doNotCreateMedicationAction:true,

    doNotCreateInsulinAction:true,

    doNotCreateRigidDailyExerciseTarget:true,

    doNotCreateRigidWaterTarget:true,

    doNotCreatePrescriptiveMealPlan:true,

    doNotInferMissingData:true

},


/*==============================================================================*
*DOCTOR QUESTION LIBRARY
*
*Maximum 3 questions.
*
*Questions help the user PREPARE for a conversation.
*
*TRESTLE must never answer questions about medicine adjustment or clinician-set
*targets itself.
*==============================================================================*/

doctorQuestionLibrary:{


/*==============================================================================*
*GLUCOSE — PERSONAL TARGETS
*==============================================================================*/

glucose_personal_targets:{

    id:"glucose_personal_targets",

    domain:"bloodSugar",

    requires:[

        "glucose_reading_recorded"

    ],

    diabetesProfiles:[

        "Prediabetes",

        "Type 1 Diabetes",

        "Type 2 Diabetes",

        "Previous Gestational Diabetes",

        "Not Sure"

    ],

    questions:[

        "What glucose ranges should I personally be aiming for at the times I usually check?",

        "Which glucose readings or patterns would you like me to pay closest attention to?",

        "Are there particular times of day when checking my glucose would be most useful for my situation?"

    ],

    priority:80,

    active:true

},


/*==============================================================================*
*MULTIPLE GLUCOSE CONTEXTS
*==============================================================================*/

glucose_context_tracking:{

    id:"glucose_context_tracking",

    domain:"bloodSugar",

    requiresAny:[

        "multiple_glucose_readings",

        "glucose_readings_at_different_contexts"

    ],

    questions:[

        "Are the different times and contexts in which I am checking glucose useful for you, or would you prefer a different monitoring pattern?",

        "When I bring several glucose readings, which patterns should I help you identify?",

        "Would you like me to continue noting whether a reading was fasting, before a meal, after a meal or at another time?"

    ],

    priority:85,

    active:true

},


/*==============================================================================*
*GESTATIONAL DIABETES / PREGNANCY
*==============================================================================*/

pregnancy_glucose_targets:{

    id:"pregnancy_glucose_targets",

    domain:"bloodSugar",

    requires:[

        "glucose_reading_recorded"

    ],

    profileRequirements:{

        lifeStageAny:[

            "Pregnant"

        ],

        diabetesProfileAny:[

            "Gestational Diabetes",

            "Type 1 Diabetes",

            "Type 2 Diabetes"

        ]

    },

    questions:[

        "What glucose targets do you want me to follow during pregnancy?",

        "When exactly would you like me to check glucose around meals?",

        "Which readings or symptoms should prompt me to contact your team rather than wait for my next appointment?"

    ],

    priority:120,

    active:true

},


/*==============================================================================*
*MEDICATION MISSED
*==============================================================================*/

medication_missed:{

    id:"doctor_medication_missed",

    domain:"medication",

    requires:[

        "medication_missed"

    ],

    questions:[

        "If I miss a dose, what would you like me to do?",

        "If remembering this medicine at the intended time is difficult, are there practical options we can discuss?",

        "Is there anything important I should know about timing this medicine around my normal workday?"

    ],

    priority:110,

    active:true

},


/*==============================================================================*
*SLEEP
*==============================================================================*/

sleep_repeated_or_relevant:{

    id:"doctor_sleep_relevant",

    domain:"sleep",

    requiresAny:[

        "clearly_shorter_sleep",

        "sleep_quality_poor"

    ],

    questions:[

        "Is there anything about my health, medicines or routine that you would want to review in relation to my sleep?",

        "If poor-quality or shorter sleep keeps recurring, what would you want me to track before our next appointment?",

        "Are there sleep-related symptoms that you would particularly want me to mention if this pattern continues?"

    ],

    priority:65,

    active:true

},


/*==============================================================================*
*PERIMENOPAUSE / MENOPAUSE + SLEEP
*==============================================================================*/

life_stage_sleep_question:{

    id:"doctor_life_stage_sleep",

    domain:"sleep",

    requiresAny:[

        "sleep_quality_poor",

        "clearly_shorter_sleep",

        "shorter_sleep"

    ],

    lifeStages:[

        "Perimenopause",

        "Menopause"

    ],

    questions:[

        "Could my life stage be relevant to the sleep changes I have been noticing, and is there anything specific you would like me to track?",

        "If sleep difficulties continue, what information would be most useful for you to review with me?",

        "Are there other health factors you would want to consider if this sleep pattern keeps recurring?"

    ],

    priority:75,

    active:true

},


/*==============================================================================*
*POSTPARTUM + MOOD / SLEEP
*==============================================================================*/

postpartum_wellbeing_question:{

    id:"doctor_postpartum_wellbeing",

    domain:"mood",

    requiresAny:[

        "mood_low",

        "sleep_quality_poor",

        "clearly_shorter_sleep"

    ],

    lifeStages:[

        "Postpartum"

    ],

    questions:[

        "If changes in sleep or mood continue, when would you want me to bring them to your attention?",

        "What changes in mood, sleep or day-to-day functioning would you want me to contact you about?",

        "Is there anything specific you would like me to track during the postpartum period?"

    ],

    priority:95,

    active:true

},


/*==============================================================================*
*PREDIABETES / PREVIOUS GDM — FOLLOW-UP CONTEXT
*==============================================================================*/

metabolic_followup_question:{

    id:"doctor_metabolic_followup",

    domain:"bloodSugar",

    requiresAny:[

        "glucose_reading_recorded",

        "multiple_glucose_readings"

    ],

    diabetesProfiles:[

        "Prediabetes",

        "Previous Gestational Diabetes",

        "Not Sure"

    ],

    questions:[

        "Would you like me to keep tracking glucose at home, and if so, when would those readings be most useful?",

        "Are there particular changes or patterns that should prompt me to arrange testing or follow-up?",

        "What monitoring would you recommend for my current metabolic risk profile?"

    ],

    priority:75,

    active:true

}

},


/*==============================================================================*
*DOCTOR QUESTION SELECTION RULES
*==============================================================================*/

doctorQuestionSelectionRules:{

    maximumQuestions:3,

    minimumPriorityForDisplay:65,

    preferProfileSpecificQuestion:true,

    preferPregnancySpecificQuestion:true,

    preferMedicationSafetyQuestionWhenMissed:true,

    avoidDuplicateMeaning:true,

    doNotForceSection:true,

    omitSectionWhenNoSupportedQuestion:true,

    neverAnswerMedicationAdjustmentQuestion:true,

    neverAnswerInsulinAdjustmentQuestion:true,

    neverCreateDiagnosisQuestionFromMissingData:true

},


/*==============================================================================*
*DOCTOR SECTION INTRO VARIANTS
*==============================================================================*/

doctorSectionIntroVariants:[

    "If you're meeting your doctor soon, these may be useful questions to take with you.",

    "If you have a health appointment coming up, your recorded day may give you a few useful questions to keep.",

    "You do not need to ask all of these. If you're seeing your doctor soon, these are the questions most closely connected to what you recorded."

],


/*==============================================================================*
*SCIENCE + FOCUS SAFETY RULES
*==============================================================================*/

scienceAndFocusSafetyRules:[

    "Science references provide general context only.",

    "Never convert a weekly physical-activity recommendation into a rigid daily percentage.",

    "Never compare water glasses to a universal target.",

    "Never interpret free-text meal descriptions as complete nutrition data.",

    "Never use a generic glucose target as the user's personal target.",

    "Never create a treatment action from medication data.",

    "Never claim Life Stage caused the user's daily observation.",

    "Never claim Promise status was achieved or failed.",

    "Tomorrow Focus must contain only one low-risk behavioural action.",

    "If no defensible focus exists, use a data-awareness fallback rather than inventing health advice."

],


/*==============================================================================*
*SECTION F END
*
*SECTION G WILL CONTINUE INSIDE THIS SAME ROOT OBJECT.
*
*DO NOT CLOSE TRESTLE_W007_INSIGHT_DATA YET.
*==============================================================================*/
/*==============================================================================*
*DAY AT A GLANCE
*
*This section controls factual report wording.
*
*No interpretation belongs here.
*==============================================================================*/

dayAtGlanceRules:{


    introVariants:[

        "Here's what you chose to record today.",

        "Your TRESTLE day, reflected back from the check-ins you chose to make.",

        "A factual view of the parts of your day you recorded."

    ],


    bloodSugarSummary:{

        domain:"bloodSugar",

        requires:[

            "glucose_reading_recorded"

        ],

        variants:[

            "You recorded {count} glucose reading{plural}.",

            "{count} glucose reading{plural} were recorded today.",

            "Your day includes {count} recorded glucose reading{plural}."

        ],

        includeContexts:true,

        includeTimes:true,

        active:true

    },


    mealSummary:{

        domain:"meal",

        requires:[

            "meal_recorded"

        ],

        variants:[

            "You recorded {count} meal or snack entr{entryPlural}.",

            "{count} meal or snack entr{entryPlural} were recorded today.",

            "Your meal timeline contains {count} recorded entr{entryPlural}."

        ],

        includeTimeline:true,

        active:true

    },


    movementSummary:{

        domain:"movement",

        requires:[

            "movement_recorded"

        ],

        variants:[

            "You recorded {minutes} minutes of movement across {sessions} session{sessionPlural}.",

            "Your recorded movement added up to {minutes} minutes across {sessions} session{sessionPlural}.",

            "Movement recorded today: {minutes} minutes across {sessions} session{sessionPlural}."

        ],

        active:true

    },


    waterSummary:{

        domain:"water",

        requires:[

            "water_logged"

        ],

        variants:[

            "You recorded {glasses} glass{glassPlural} of water.",

            "Water recorded today: {glasses} glass{glassPlural}.",

            "Your latest water check-in shows {glasses} glass{glassPlural}."

        ],

        active:true

    },


    sleepSummary:{

        domain:"sleep",

        requires:[

            "sleep_recorded"

        ],

        variants:[

            "You recorded {hours} hours of sleep and rated its quality as {quality}.",

            "Sleep recorded: {hours} hours, rated {quality}.",

            "Your sleep check-in shows {hours} hours with {quality} quality."

        ],

        active:true

    },


    stressSummary:{

        domain:"stress",

        requires:[

            "stress_recorded"

        ],

        variants:[

            "You described today's stress as {level}.",

            "Stress was recorded as {level}.",

            "Your stress check-in was {level}."

        ],

        active:true

    },


    moodSummary:{

        domain:"mood",

        requires:[

            "mood_recorded"

        ],

        variants:[

            "You described your mood as {mood}.",

            "Mood was recorded as {mood}.",

            "Your mood check-in was {mood}."

        ],

        active:true

    },


    medicationSummary:{

        domain:"medication",

        requires:[

            "medication_status_recorded"

        ],

        variants:[

            "Medication was recorded as {status}.",

            "Your medication check-in was marked {status}.",

            "You recorded your medication status as {status}."

        ],

        active:true

    }

},


/*==============================================================================*
*DAY AT A GLANCE ORDER
*==============================================================================*/

dayAtGlanceOrder:[

    "sleep",

    "movement",

    "water",

    "meal",

    "bloodSugar",

    "mood",

    "stress",

    "medication"

],


/*==============================================================================*
*PROMISE REFLECTION LIBRARY
*
*This is the signature personalization section.
*
*Reflection must use:
*
*Promise
*+
*actual supported pattern
*
*Never Promise alone.
*==============================================================================*/

promiseReflectionLibrary:{


/*==============================================================================*
*BALANCED LIFE
*==============================================================================*/

balanced_life_stress:{

    id:"balanced_life_stress",

    promise:"Balanced Life",

    domain:"stress",

    requires:[

        "stress_high"

    ],

    variants:[

        "Your Balanced Life Promise gives today's high-stress check-in special relevance. TRESTLE does not treat the day as a failure; it simply identifies stress as the clearest part of the day worth noticing.",

        "For your Balanced Life Promise, today's strongest recorded signal was high stress. Balance does not mean every day feels even—it means noticing where the day placed the most pressure.",

        "Your Balanced Life Promise is about the whole day. Today, stress stood out more clearly than the other parts you recorded."

    ],

    priority:100,

    active:true

},


balanced_life_movement:{

    id:"balanced_life_movement",

    promise:"Balanced Life",

    domain:"movement",

    requires:[

        "movement_recorded"

    ],

    variants:[

        "Your Balanced Life Promise is supported by the fact that you made some room for movement today.",

        "Movement was one part of your day that sat comfortably with your Balanced Life Promise.",

        "Your recorded movement gives your Balanced Life Promise one concrete positive to carry forward."

    ],

    priority:85,

    active:true

},


/*==============================================================================*
*MORE ENERGY
*==============================================================================*/

more_energy_sleep:{

    id:"more_energy_sleep",

    promise:"More Energy",

    domain:"sleep",

    requiresAny:[

        "clearly_shorter_sleep",

        "shorter_sleep",

        "sleep_quality_poor"

    ],

    variants:[

        "Because More Energy is your Promise, sleep becomes the clearest supported area to notice today. TRESTLE does not claim your energy was low—it simply recognizes sleep as a relevant part of the picture you recorded.",

        "Your More Energy Promise makes today's less favourable sleep entry especially relevant, without pretending that TRESTLE directly measured your energy.",

        "For a More Energy Promise, the sleep you recorded is the strongest evidence-based place to focus without making assumptions about how energetic you actually felt."

    ],

    priority:105,

    active:true

},


more_energy_movement:{

    id:"more_energy_movement",

    promise:"More Energy",

    domain:"movement",

    requires:[

        "movement_recorded"

    ],

    variants:[

        "You made room for movement today, which is a useful behaviour to protect in the direction of your More Energy Promise.",

        "Movement was one supportive behaviour you actually recorded today, making it relevant to your More Energy Promise.",

        "Your More Energy Promise does not require TRESTLE to invent an energy score. Today's movement is simply one real behaviour worth keeping."

    ],

    priority:80,

    active:true

},


/*==============================================================================*
*BETTER SLEEP
*==============================================================================*/

better_sleep_shorter:{

    id:"better_sleep_shorter",

    promise:"Better Sleep",

    domain:"sleep",

    requiresAny:[

        "clearly_shorter_sleep",

        "shorter_sleep"

    ],

    variants:[

        "Better Sleep is your Promise, and today's recorded sleep duration gives TRESTLE a clear, evidence-based place to focus.",

        "Your Better Sleep Promise and the sleep duration you recorded point in the same direction: sleep deserves first attention in today's reflection.",

        "Because you chose Better Sleep, the shorter sleep you recorded is the most directly relevant part of today's TRESTLE picture."

    ],

    priority:115,

    active:true

},


better_sleep_quality:{

    id:"better_sleep_quality",

    promise:"Better Sleep",

    domain:"sleep",

    requires:[

        "sleep_quality_poor"

    ],

    variants:[

        "Your Better Sleep Promise makes today's poor-rated sleep quality particularly relevant, without implying a diagnosis or a cause.",

        "Because Better Sleep is your Promise, the quality you assigned to last night's sleep is one of the clearest things worth carrying forward.",

        "Today's sleep-quality check-in is directly relevant to your Better Sleep Promise and deserves attention without turning one night into a larger conclusion."

    ],

    priority:110,

    active:true

},


better_sleep_success:{

    id:"better_sleep_success",

    promise:"Better Sleep",

    domain:"sleep",

    requires:[

        "adult_sleep_reference_met",

        "sleep_quality_good"

    ],

    variants:[

        "Your sleep entry sat well with your Better Sleep Promise today. The useful insight may simply be that something in yesterday's routine is worth protecting.",

        "Better Sleep is your Promise, and today's sleep check-in gives you something positive to preserve rather than something new to fix.",

        "Your recorded sleep aligned well with your Better Sleep Promise. TRESTLE's role here is to help you notice what worked."

    ],

    priority:105,

    active:true

},


/*==============================================================================*
*MORE CALMNESS
*==============================================================================*/

more_calmness_high_stress:{

    id:"more_calmness_high_stress",

    promise:"More Calmness",

    domain:"stress",

    requires:[

        "stress_high"

    ],

    variants:[

        "Your More Calmness Promise makes today's high-stress check-in the clearest part of the day worth noticing.",

        "More Calmness is your chosen direction, so today's high stress deserves attention without turning the day into a judgement.",

        "Because you chose More Calmness, your stress check-in carries more weight in today's reflection than less relevant metrics."

    ],

    priority:115,

    active:true

},


more_calmness_low_stress:{

    id:"more_calmness_low_stress",

    promise:"More Calmness",

    domain:"stress",

    requires:[

        "stress_low"

    ],

    variants:[

        "Today's low-stress check-in sat well with your More Calmness Promise. The useful question is what about the day felt more manageable.",

        "Your More Calmness Promise already found some support in today's low-stress entry. Protecting that rhythm may matter more than adding another task.",

        "You described stress as low today, which is worth noticing in the context of your More Calmness Promise."

    ],

    priority:100,

    active:true

},


/*==============================================================================*
*BETTER FOCUS
*==============================================================================*/

better_focus_stress:{

    id:"better_focus_stress",

    promise:"Better Focus",

    domain:"stress",

    requires:[

        "stress_high"

    ],

    variants:[

        "Better Focus is your Promise, but focus itself was not directly measured. Today's high-stress check-in is therefore a relevant supporting observation—not proof that your concentration was poor.",

        "Because W005 does not measure concentration directly, your Better Focus Promise uses today's high-stress entry only as supporting context.",

        "Your Better Focus Promise makes stress useful to notice, while TRESTLE avoids pretending it measured your actual concentration."

    ],

    priority:105,

    active:true

},


better_focus_sleep:{

    id:"better_focus_sleep",

    promise:"Better Focus",

    domain:"sleep",

    requiresAny:[

        "clearly_shorter_sleep",

        "shorter_sleep",

        "sleep_quality_poor"

    ],

    variants:[

        "Your Better Focus Promise gives sleep additional relevance today, but TRESTLE does not claim that your recorded sleep determined your concentration.",

        "Because focus itself was not measured, the sleep you recorded is treated only as a relevant supporting part of your Better Focus Promise.",

        "Today's sleep entry is useful context for your Better Focus Promise without becoming an explanation for how focused you were."

    ],

    priority:95,

    active:true

},


/*==============================================================================*
*HEALTHIER LIVING
*==============================================================================*/

healthier_living_movement:{

    id:"healthier_living_movement",

    promise:"Healthier Living",

    domain:"movement",

    requires:[

        "movement_recorded"

    ],

    variants:[

        "Your recorded movement is one concrete behaviour already moving in the direction of your Healthier Living Promise.",

        "For Healthier Living, today's movement is more useful than a generic score because it is something you actually did and recorded.",

        "Your Healthier Living Promise is built from repeatable behaviours, and today's movement is one of those behaviours."

    ],

    priority:110,

    active:true

},


healthier_living_sleep:{

    id:"healthier_living_sleep",

    promise:"Healthier Living",

    domain:"sleep",

    requiresAny:[

        "sleep_quality_good",

        "adult_sleep_reference_met",

        "sleep_quality_poor",

        "shorter_sleep",

        "clearly_shorter_sleep"

    ],

    variants:[

        "Sleep is one of the health behaviours relevant to your Healthier Living Promise. Today's entry gives TRESTLE a real point of reflection without turning it into a score.",

        "Your Healthier Living Promise includes sustainable routines, and the sleep you recorded is one useful part of that wider picture.",

        "Today's sleep entry is relevant to your Healthier Living Promise because it reflects a real daily behaviour rather than an abstract health target."

    ],

    priority:90,

    active:true

}

},


/*==============================================================================*
*PROMISE REFLECTION SELECTION RULES
*==============================================================================*/

promiseReflectionSelectionRules:{

    maximumReflections:1,

    requirePromiseMatch:true,

    requireRecordedEvidence:true,

    preferHighestPriorityRule:true,

    preferPositiveRuleWhenEquallyRelevant:true,

    neverForceNegativeNarrative:true,

    neverUsePromiseAlone:true,

    useSparseVariantWhenNoSupportedPattern:true

},


/*==============================================================================*
*CONTRADICTION HANDLING
*
*The engine must preserve mixed daily states rather than flatten them into
*"good day" / "bad day".
*==============================================================================*/

contradictionRules:{


    goodMoodHighStress:{

        id:"contradiction_good_mood_high_stress",

        requires:[

            "mood_good",

            "stress_high"

        ],

        variants:[

            "You described the day as high stress while still rating your mood as good. Both can be true, and today's check-ins capture that distinction.",

            "High stress and a good mood appeared together today. TRESTLE keeps both observations rather than forcing the day into a single positive or negative label.",

            "Your mood and stress entries moved in different directions today, which is useful information in itself."

        ],

        priority:95,

        active:true

    },


    poorSleepGoodMood:{

        id:"contradiction_poor_sleep_good_mood",

        requiresAnySleep:[

            "sleep_quality_poor",

            "clearly_shorter_sleep",

            "shorter_sleep"

        ],

        requires:[

            "mood_good"

        ],

        variants:[

            "Sleep was less favourable in what you recorded, while your mood was still good. Today's entries do not all point in one direction.",

            "You recorded less favourable sleep alongside a good mood. TRESTLE treats both as valid observations rather than assuming one should have determined the other.",

            "Your sleep and mood entries tell different parts of today's story, and both are worth keeping."

        ],

        priority:85,

        active:true

    },


    highStressMovementPresent:{

        id:"contradiction_high_stress_movement",

        requires:[

            "stress_high",

            "movement_recorded"

        ],

        variants:[

            "You described today as stressful and still made room for movement. A demanding day can contain supportive behaviours too.",

            "High stress did not erase the fact that you made some room for movement today.",

            "Even within a high-stress day, your movement entry gives you one positive behaviour worth keeping."

        ],

        priority:90,

        active:true

    }

},


/*==============================================================================*
*CONTRADICTION OUTPUT RULES
*==============================================================================*/

contradictionOutputRules:{

    maximumContradictions:1,

    useOnlyWhenItImprovesAccuracy:true,

    preferOverSimplisticPositiveNegativeStory:true,

    neverTreatContradictionAsClinicalFinding:true

},


/*==============================================================================*
*SPARSE DATA REPORT WORDING
*==============================================================================*/

sparseDataWording:{


    none:{

        dataLevel:"NONE",

        title:"Today's TRESTLE Insight",

        message:

            "There wasn't enough recorded today to create a meaningful TRESTLE Insight. Your next day begins fresh.",

        allowPdf:false,

        allowShare:false,

        allowScience:false,

        allowDoctorQuestions:false

    },


    veryLight:{

        dataLevel:"VERY_LIGHT",

        introVariants:[

            "Today's reflection is intentionally brief because you recorded only one part of your day.",

            "You recorded one part of your day today, so TRESTLE will keep this Insight simple rather than filling the gaps.",

            "There is only one recorded check-in to reflect on today. TRESTLE will not turn that into a larger story."

        ],

        closingVariants:[

            "A small amount of real information is more useful than a fuller report built on assumptions.",

            "TRESTLE would rather keep the reflection short than invent what was not recorded.",

            "Tomorrow begins fresh. Record only what genuinely feels useful."

        ],

        allowPdf:true,

        allowShare:true

    },


    light:{

        dataLevel:"LIGHT",

        introVariants:[

            "Today's Insight is based on a limited set of check-ins, so the reflection stays focused on what is actually known.",

            "You recorded a few parts of your day today. TRESTLE will reflect those without filling in the missing pieces.",

            "Today's picture is partial, but there is still enough to reflect back what you chose to record."

        ],

        allowPdf:true,

        allowShare:true

    },


    full:{

        dataLevel:"FULL",

        introVariants:[

            "Today's TRESTLE Insight is shaped by the check-ins you chose to record.",

            "Your day has enough recorded detail for TRESTLE to reflect several parts of it back to you.",

            "Today's reflection is based entirely on the information you chose to capture."

        ],

        allowPdf:true,

        allowShare:true

    }

},


/*==============================================================================*
*REPORT CLOSING LIBRARY
*==============================================================================*/

closingVariants:[

    "A reflection from your day, not a judgement of it.",

    "Your day reflected back to you—without turning it into a score.",

    "TRESTLE helps you notice your day. It does not define it.",

    "What you recorded is information, not a verdict."

],


/*==============================================================================*
*GENERAL DISCLAIMER
*==============================================================================*/

generalDisclaimer:

    "TRESTLE Insight reflects information you chose to record and may place it alongside established health guidance for general context. It is not a diagnosis, medical advice, or a substitute for recommendations from your healthcare professional.",


/*==============================================================================*
*PREGNANCY DISCLAIMER
*==============================================================================*/

pregnancyDisclaimer:

    "During pregnancy, glucose targets, medicines, activity and nutrition should follow the plan agreed with your obstetric or diabetes care team. TRESTLE Insight provides reflection and general context only.",


/*==============================================================================*
*FINAL SAFETY BLACKLIST
*
*The final composer should reject or block wording containing these claims.
*
*This is an additional safeguard.
*==============================================================================*/

finalSafetyBlacklist:[

    "you are diabetic",

    "you do not have diabetes",

    "your diabetes is controlled",

    "your diabetes is uncontrolled",

    "your glucose is dangerous",

    "your glucose is safe",

    "your glucose is normal",

    "your glucose is abnormal",

    "your meal caused",

    "your stress caused",

    "your sleep caused",

    "your exercise caused",

    "your movement caused",

    "your medication caused",

    "your hormones caused",

    "perimenopause caused",

    "menopause caused",

    "pregnancy caused",

    "postpartum caused",

    "you have depression",

    "you have anxiety",

    "you have a sleep disorder",

    "take more insulin",

    "take less insulin",

    "skip insulin",

    "change your insulin",

    "double your dose",

    "take a missed dose now",

    "stop your medication",

    "increase your medication",

    "reduce your medication",

    "you failed",

    "you achieved your health target",

    "you were sedentary",

    "you skipped meals",

    "you were dehydrated",

    "you were adequately hydrated",

    "you had low energy",

    "you had high energy",

    "your focus was poor",

    "your focus improved"

],


/*==============================================================================*
*FINAL COMPOSER RULES
*==============================================================================*/

finalComposerRules:{

    useRecordedFacts:true,

    useCalculatedFacts:true,

    useApprovedContextOnly:true,

    maximumScienceSections:2,

    maximumPromiseReflections:1,

    maximumTomorrowFocus:1,

    maximumDoctorQuestions:3,

    maximumContradictionObservations:1,

    omitUnsupportedSections:true,

    neverFillSpaceForAppearance:true,

    neverInventMissingData:true,

    neverCreateHealthScore:true,

    neverCreateSuccessPercentage:true,

    neverCreateGenericWaterTarget:true,

    neverCreateGenericGlucoseTarget:true,

    neverCreateMedicationInstruction:true,

    neverCreateDiagnosis:true,

    runFinalSafetyBlacklist:true

},


/*==============================================================================*
*SECTION G END
*
*SECTION H WILL CLOSE AND EXPORT THE DATA OBJECT.
*
*DO NOT CLOSE TRESTLE_W007_INSIGHT_DATA YET.
*==============================================================================*/
/*==============================================================================*
*FINAL INSIGHT OUTPUT SCHEMA
*
*The W007 engine must compose one object in this shape.
*
*The reader popup, PDF and Share functions will all use this same object.
*==============================================================================*/

outputSchema:{


    version:"1.0",


    fields:{


        date:{

            type:"string",

            required:true,

            format:"YYYY-MM-DD"

        },


        generatedAt:{

            type:"string",

            required:true,

            format:"ISO-8601"

        },


        identity:{

            type:"object",

            required:true,

            fields:{

                firstName:{

                    type:"string",

                    required:false

                }

            }

        },


        profile:{

            type:"object",

            required:true,

            fields:{

                promise:{

                    type:"string",

                    required:false

                },


                lifeStage:{

                    type:"string",

                    required:false

                },


                diabetesProfile:{

                    type:"string",

                    required:false

                }

            }

        },


        dataCoverage:{

            type:"object",

            required:true,

            fields:{

                checkinsLogged:{

                    type:"number",

                    required:true

                },


                bloodSugarReadings:{

                    type:"number",

                    required:true

                },


                mealsRecorded:{

                    type:"number",

                    required:true

                },


                movementSessions:{

                    type:"number",

                    required:true

                },


                dataLevel:{

                    type:"string",

                    required:true,

                    allowed:[

                        "NONE",

                        "VERY_LIGHT",

                        "LIGHT",

                        "FULL"

                    ]

                }

            }

        },


        dayAtGlance:{

            type:"object",

            required:true

        },


        scienceAndYourDay:{

            type:"array",

            required:true,

            maximumItems:2

        },


        promiseInsight:{

            type:"object",

            required:false,

            fields:{

                promise:{

                    type:"string",

                    required:false

                },


                text:{

                    type:"string",

                    required:true

                }

            }

        },


        tomorrowFocus:{

            type:"string",

            required:false

        },


        doctorQuestions:{

            type:"array",

            required:true,

            maximumItems:3

        },


        contradictionObservation:{

            type:"string",

            required:false

        },


        disclaimer:{

            type:"string",

            required:true

        },


        sourceIds:{

            type:"array",

            required:true

        }

    }

},


/*==============================================================================*
*SOURCE REGISTRY
*
*Provides compact source metadata for the reader/PDF footer.
*
*The report should not become an academic paper.
*
*Only sources actually used in that Insight should be shown.
*==============================================================================*/

sourceRegistry:{


    who_adult_physical_activity:{

        id:"who_adult_physical_activity",

        authority:"World Health Organization",

        displayAuthority:"WHO",

        title:

            "Guidelines on Physical Activity and Sedentary Behaviour",

        year:2020,

        domain:"movement"

    },


    who_adult_physical_activity_additional:{

        id:"who_adult_physical_activity_additional",

        authority:"World Health Organization",

        displayAuthority:"WHO",

        title:

            "Guidelines on Physical Activity and Sedentary Behaviour",

        year:2020,

        domain:"movement"

    },


    ada_diabetes_physical_activity:{

        id:"ada_diabetes_physical_activity",

        authority:"American Diabetes Association",

        displayAuthority:"ADA",

        title:

            "Standards of Care in Diabetes—2026: Facilitating Positive Health Behaviors and Well-being",

        year:2026,

        domain:"movement"

    },


    ada_sleep_health:{

        id:"ada_sleep_health",

        authority:"American Diabetes Association",

        displayAuthority:"ADA",

        title:

            "Standards of Care in Diabetes—2026: Facilitating Positive Health Behaviors and Well-being",

        year:2026,

        domain:"sleep"

    },


    adult_sleep_duration_reference:{

        id:"adult_sleep_duration_reference",

        authority:"General Adult Sleep Guidance",

        displayAuthority:"Sleep Guidance",

        title:

            "General adult sleep-duration reference",

        year:null,

        domain:"sleep"

    },


    ada_psychosocial_wellbeing:{

        id:"ada_psychosocial_wellbeing",

        authority:"American Diabetes Association",

        displayAuthority:"ADA",

        title:

            "Standards of Care in Diabetes—2026: Facilitating Positive Health Behaviors and Well-being",

        year:2026,

        domain:"stress"

    },


    who_healthy_diet_fruit_vegetables:{

        id:"who_healthy_diet_fruit_vegetables",

        authority:"World Health Organization",

        displayAuthority:"WHO",

        title:

            "Healthy Diet Fact Sheet",

        year:2026,

        domain:"meal"

    },


    niddk_diabetes_healthy_living:{

        id:"niddk_diabetes_healthy_living",

        authority:

            "National Institute of Diabetes and Digestive and Kidney Diseases",

        displayAuthority:"NIDDK",

        title:

            "Healthy Living with Diabetes",

        year:null,

        domain:"general"

    },


    niddk_activity_glucose_safety:{

        id:"niddk_activity_glucose_safety",

        authority:

            "National Institute of Diabetes and Digestive and Kidney Diseases",

        displayAuthority:"NIDDK",

        title:

            "Healthy Living with Diabetes",

        year:null,

        domain:"bloodSugar"

    },


    ada_individualized_glucose_goals:{

        id:"ada_individualized_glucose_goals",

        authority:"American Diabetes Association",

        displayAuthority:"ADA",

        title:

            "Standards of Care in Diabetes—2026",

        year:2026,

        domain:"bloodSugar"

    },


    pregnancy_glucose_individualized_care:{

        id:"pregnancy_glucose_individualized_care",

        authority:"Pregnancy Diabetes Clinical Guidance",

        displayAuthority:"Pregnancy Guidance",

        title:

            "Pregnancy and diabetes clinical guidance",

        year:null,

        domain:"bloodSugar"

    }

},


/*==============================================================================*
*SOURCE OUTPUT RULES
*==============================================================================*/

sourceOutputRules:{

    maximumSources:3,

    showOnlyUsedSources:true,

    removeDuplicateSources:true,

    showAuthority:true,

    showTitle:true,

    showYearWhenAvailable:true,

    doNotShowRawURLsInInsight:true,

    doNotShowUnusedReferences:true

},


/*==============================================================================*
*REPORT SECTION CONFIGURATION
*==============================================================================*/

reportSections:{


    header:{

        enabled:true,

        title:"Your TRESTLE Insight"

    },


    dayAtGlance:{

        enabled:true,

        title:"Your Day at a Glance"

    },


    scienceAndYourDay:{

        enabled:true,

        title:"Science & Your Day",

        optional:true

    },


    promiseInsight:{

        enabled:true,

        title:"In the Direction of Your Promise",

        optional:true

    },


    tomorrowFocus:{

        enabled:true,

        title:"One Thing to Carry Into Tomorrow",

        optional:true

    },


    doctorQuestions:{

        enabled:true,

        title:"If You're Meeting Your Doctor Soon",

        optional:true

    },


    sources:{

        enabled:true,

        title:"References",

        optional:true

    },


    disclaimer:{

        enabled:true

    }

},


/*==============================================================================*
*7 PM GENERATION CONFIG
*==============================================================================*/

generationRules:{

    localHour:19,

    localMinute:0,

    generateOncePerCalendarDay:true,

    regenerateAutomatically:false,

    requireBackend:false,

    requireGAS:false,

    requireNetwork:false,

    generationMode:

        "FIRST_TRESTLE_OPEN_AT_OR_AFTER_19_00",

    beforeGenerationMessage:

        "Your end-of-day TRESTLE Insight will be ready after 7 PM.",

    alreadyGeneratedBehavior:

        "LOAD_SAVED_INSIGHT"

},


/*==============================================================================*
*ARCHIVE CONFIGURATION
*==============================================================================*/

archiveRules:{

    storageKey:

        "trestle_w007_insights",

    maximumInsights:7,

    storePdfBinary:false,

    storeStructuredInsight:true,

    sortNewestFirst:true,

    cleanupOnLoad:true,

    cleanupOnSave:true,

    removeOldestWhenLimitExceeded:true

},


/*==============================================================================*
*READER CONFIGURATION
*==============================================================================*/

readerRules:{

    modalMode:true,

    largeReader:true,

    interactiveReportContent:false,

    allowClose:true,

    allowDownload:true,

    allowShare:true,

    allowEditing:false,

    allowInlineCheckins:false,

    showSourcesWhenUsed:true,

    showDisclaimer:true

},


/*==============================================================================*
*PDF CONFIGURATION
*==============================================================================*/

pdfRules:{

    enabled:true,

    preferredPageSize:"A4",

    preferredPageCount:1,

    allowTwoPagesWhenNeeded:true,

    useSameInsightObjectAsReader:true,

    includeSources:true,

    includeDisclaimer:true,

    includeDoctorQuestions:true,

    includeInteractiveControls:false,

    storePdfInLocalStorage:false

},


/*==============================================================================*
*SHARE CONFIGURATION
*==============================================================================*/

shareRules:{

    enabled:true,

    preferNativeWebShare:true,

    preferPdfFileWhenSupported:true,

    fallbackToDownload:true,

    fallbackToTextSummary:true,

    neverAutoShare:true,

    userActionRequired:true

},


/*==============================================================================*
*INSIGHT VALIDATION RULES
*
*The W007 engine should run these checks before saving the final Insight.
*==============================================================================*/

validationRules:{


    requireValidDate:true,

    requireGeneratedAt:true,

    requireDataCoverage:true,

    requireDayAtGlanceObject:true,

    requireDisclaimer:true,


    validatePromiseAgainstSupportedList:true,

    validateLifeStageAgainstSupportedList:true,

    validateDiabetesProfileAgainstSupportedList:true,


    validateScienceReferenceIds:true,

    validateSourceIds:true,


    maximumScienceReferences:2,

    maximumDoctorQuestions:3,

    maximumTomorrowFocus:1,


    rejectUnsupportedDiagnosis:true,

    rejectUnsupportedCausation:true,

    rejectTreatmentAdvice:true,

    rejectMedicationAdjustment:true,

    rejectGenericGlucoseTarget:true,

    rejectGenericWaterTarget:true,

    rejectMissingDataInference:true,

    rejectHealthScore:true,

    rejectSuccessPercentage:true,


    runSafetyBlacklist:true

},


/*==============================================================================*
*VALIDATION FAILURE BEHAVIOR
*==============================================================================*/

validationFailureRules:{

    discardInvalidSentence:true,

    discardInvalidSectionWhenNecessary:true,

    doNotBreakEntireInsightForOptionalFailure:true,

    allowFactualFallback:true,

    allowSparseFallback:true,

    logWarningToConsole:true,

    neverExposeTechnicalErrorToUser:true

},


/*==============================================================================*
*FALLBACK REPORT MESSAGES
*==============================================================================*/

fallbackMessages:{


    profileMissing:

        "TRESTLE could reflect what you recorded today, but your Promise or profile context was not available, so no profile-based interpretation was added.",


    w005Unavailable:

        "Today's Insight couldn't be prepared from the available Quick Check-in information.",


    scienceUnavailable:

        "Today's reflection is based on what you recorded. No additional scientific reference was needed for this Insight.",


    promiseUnavailable:

        "Today's reflection stays factual because a TRESTLE Promise was not available.",


    noDoctorQuestion:

        "No specific doctor question was generated from today's recorded information."

},


/*==============================================================================*
*FINAL DATA OBJECT METADATA
*==============================================================================*/

metadata:{

    module:"W007",

    name:"Your TRESTLE Insight",

    dataFile:

        "TRESTLE_W007_Insight_Data.js",

    architecture:

        "LOCAL_BROWSER_RULE_ENGINE",

    backendRequired:false,

    gasRequired:false,

    aiRequired:false,

    personalDailyDataUploadRequired:false,

    insightArchiveLocation:

        "localStorage",

    insightGenerationTime:

        "After 7 PM local time",

    maximumArchivedInsights:7

}


/*==============================================================================*
*END ROOT DATA OBJECT
*==============================================================================*/

};


/*==============================================================================*
*PUBLIC EXPORT
*
*Expose controlled W007 reference/rule data to the W007 engine.
*==============================================================================*/

window.TRESTLE_W007_INSIGHT_DATA=
    TRESTLE_W007_INSIGHT_DATA;


/*==============================================================================*
*TRESTLE W007
*INSIGHT DATA
*Version 1.0
*COMPLETE
*==============================================================================*/
/*==============================================================================*
*TRESTLE W007
*INSIGHT DATA v2 RUNTIME UPGRADE
*
*Extends the existing v1 rule library without replacing it.
*==============================================================================*/

(function upgradeTrestleW007DataV2(){

    const DATA =
        window.TRESTLE_W007_INSIGHT_DATA;


    if(
        !DATA ||
        typeof DATA!=="object"
    ){

        console.warn(
            "TRESTLE W007 Data v2 upgrade skipped: base data object unavailable."
        );

        return;

    }


    /*==========================================================================
    VERSION
    ==========================================================================*/

    DATA.version=
        "2.0";


    /*==========================================================================
    W005 STRESS SOURCE
    ==========================================================================*/

    DATA.stressSourceRules={

        enabled:true,

        optional:true,

        field:"source",

        supportedSources:[

            "Professional / Work",

            "Family",

            "Personal",

            "Social",

            "Other",

            "Prefer not to say"

        ],


        principles:[

            "Stress source is user-selected context, not an inferred cause.",

            "A source may be recorded with Low, Moderate or High stress.",

            "Do not infer a source when the user does not select one.",

            "Do not convert free-text notes into a stress-source category.",

            "Do not diagnose a mental-health condition from stress level or source.",

            "Professional / Work may be reflected factually as the source selected by the user; do not state that work caused a health outcome."

        ]

    };


    if(
        DATA.derivedPatternRules &&
        DATA.derivedPatternRules.stress
    ){

        DATA.derivedPatternRules
            .stress
            .sourceRecorded={

                id:
                    "stress_source_recorded",

                domain:
                    "stress",

                evidenceClass:
                    "A",

                condition:
                    "stress entry contains a supported source selected by the user",

                priority:
                    65,

                active:
                    true

            };

    }


    /*==========================================================================
    TRESTLE INTELLIGENCE v2
    ==========================================================================*/

    DATA.intelligenceV2Rules={


        signatureSequence:[

            "NOTICE",

            "THREAD",

            "CONTRAST",

            "PROMISE",

            "ONE_THING"

        ],


        /*----------------------------------------------------------------------
        NOTICE
        ----------------------------------------------------------------------*/

        notice:{

            maximumItems:1,

            minimumStructuredDays:1,

            preferDerivedObservation:true,

            preferRelationshipOverRawRestatement:true,

            neverInventMissingData:true

        },


        /*----------------------------------------------------------------------
        THREAD
        ----------------------------------------------------------------------*/

        thread:{

            maximumItems:1,

            minimumStructuredDays:3,


            thresholds:[


                {

                    availableDays:3,

                    minimumOccurrences:2,

                    wording:
                        "may be beginning to appear"

                },


                {

                    minimumAvailableDays:4,

                    maximumAvailableDays:5,

                    minimumOccurrences:3,

                    wording:
                        "has appeared repeatedly"

                },


                {

                    minimumAvailableDays:6,

                    maximumAvailableDays:7,

                    minimumOccurrences:4,

                    wording:
                        "has been a recurring feature of your recent recorded days"

                }

            ],


            requiredQualifier:

                "This is a pattern in what you recorded, not a diagnosis or proof of cause and effect.",


            neverUseCalendarWeekLanguageUnlessSupported:
                true

        },


        /*----------------------------------------------------------------------
        CONTRAST
        ----------------------------------------------------------------------*/

        contrast:{

            maximumItems:1,

            minimumComparableDays:4,

            minimumObservationsPerSide:2,

            requireLikeForLikeComparison:true,


            requiredQualifier:

                "This does not establish that one caused the other. It is a contrast in your recorded information.",


            neverUseSingleDayVsGroupComparison:true

        },


        /*----------------------------------------------------------------------
        PROMISE
        ----------------------------------------------------------------------*/

        promise:{

            requirePromiseWhenAvailable:true,

            promiseCreatesEvidence:false,

            promiseChangesPriorityOnly:true,


            preferredEvidenceOrder:[

                "THREAD",

                "CONTRAST",

                "NOTICE",

                "SUPPORTED_DAILY_PATTERN"

            ],


            neverClaimPromiseAchieved:true,

            neverClaimPromiseFailed:true

        },


        /*----------------------------------------------------------------------
        ONE THING
        ----------------------------------------------------------------------*/

        oneThing:{

            maximumItems:1,

            preferRecurringPattern:true,

            preferStrongContrast:true,

            preferMeaningfulNotice:true,

            allowMaintainSuccess:true,

            neverCreateChecklist:true,

            neverCreateTreatmentAction:true

        },


        /*----------------------------------------------------------------------
        MATURITY
        ----------------------------------------------------------------------*/

        maturity:{

            oneToTwoDays:
                "NOTICING",

            threeToFourDays:
                "CONNECTING",

            fiveToSevenDays:
                "RECOGNISING"

        },


        silenceAllowed:true,

        omitUnsupportedSections:true

    };


    /*==========================================================================
    OUTPUT SCHEMA v2
    ==========================================================================*/

    if(
        DATA.outputSchema &&
        DATA.outputSchema.fields
    ){

        DATA.outputSchema.version=
            "2.0";


        DATA.outputSchema
            .fields
            .intelligenceSnapshot={

                type:
                    "object",

                required:
                    true,

                description:
                    "Structured browser-local daily facts used for safe longitudinal comparison."

            };


        DATA.outputSchema
            .fields
            .notice={

                type:
                    "object",

                required:
                    false,

                fields:{

                    id:{
                        type:"string",
                        required:true
                    },

                    domain:{
                        type:"string",
                        required:true
                    },

                    text:{
                        type:"string",
                        required:true
                    },

                    evidenceClass:{
                        type:"string",
                        required:true
                    }

                }

            };


        DATA.outputSchema
            .fields
            .thread={

                type:
                    "object",

                required:
                    false,

                fields:{

                    id:{
                        type:"string",
                        required:true
                    },

                    domain:{
                        type:"string",
                        required:true
                    },

                    text:{
                        type:"string",
                        required:true
                    },

                    count:{
                        type:"number",
                        required:false
                    },

                    comparableDays:{
                        type:"number",
                        required:false
                    },

                    caution:{
                        type:"string",
                        required:false
                    }

                }

            };


        DATA.outputSchema
            .fields
            .contrast={

                type:
                    "object",

                required:
                    false,

                fields:{

                    id:{
                        type:"string",
                        required:true
                    },

                    domain:{
                        type:"string",
                        required:true
                    },

                    text:{
                        type:"string",
                        required:true
                    },

                    groups:{
                        type:"object",
                        required:false
                    },

                    caution:{
                        type:"string",
                        required:false
                    }

                }

            };


        DATA.outputSchema
            .fields
            .intelligenceDays={

                type:
                    "number",

                required:
                    true,

                minimum:
                    1,

                maximum:
                    7

            };


        /*
        v1 described tomorrowFocus as a string.
        The production engine uses a structured object.
        */

        DATA.outputSchema
            .fields
            .tomorrowFocus={

                type:
                    "object",

                required:
                    false,

                fields:{

                    id:{
                        type:"string",
                        required:false
                    },

                    domain:{
                        type:"string",
                        required:false
                    },

                    text:{
                        type:"string",
                        required:true
                    }

                }

            };

    }


    /*==========================================================================
    REPORT HIERARCHY v2
    ==========================================================================*/

    DATA.reportSections={


        header:{

            enabled:true,

            title:
                "TRESTLE Insight",

            subtitle:
                "Your day, noticed."

        },


        dayAtGlance:{

            enabled:true,

            title:
                "Your Day at a Glance"

        },


        notice:{

            enabled:true,

            title:
                "TRESTLE NOTICE",

            subtitle:
                "What stood out today",

            optional:true

        },


        thread:{

            enabled:true,

            title:
                "TRESTLE THREAD",

            subtitle:
                "What keeps appearing",

            optional:true,

            minimumStructuredDays:
                3

        },


        contrast:{

            enabled:true,

            title:
                "TRESTLE CONTRAST",

            subtitle:
                "What looked different",

            optional:true,

            minimumComparableDays:
                4

        },


        promiseInsight:{

            enabled:true,

            title:
                "YOUR PROMISE",

            subtitle:
                "Your direction, reflected in today's evidence",

            optional:true,

            requiredWhenPromiseAvailable:
                true

        },


        tomorrowFocus:{

            enabled:true,

            title:
                "ONE THING",

            subtitle:
                "One thing worth carrying forward",

            optional:true

        },


        scienceAndYourDay:{

            enabled:true,

            title:
                "Science & Your Day",

            optional:true,

            supportingSection:true

        },


        doctorQuestions:{

            enabled:true,

            title:
                "Questions Worth Carrying to Your Doctor",

            optional:true,

            supportingSection:true,

            doNotForceDaily:true

        },


        sources:{

            enabled:true,

            title:
                "Guidance Referenced",

            optional:true,

            supportingSection:true

        },


        disclaimer:{

            enabled:true

        }

    };


    /*==========================================================================
    DOCTOR QUESTIONS
    ==========================================================================*/

    DATA.doctorQuestionSelectionRules=
        Object.assign(

            {},

            DATA.doctorQuestionSelectionRules ||
                {},

            {

                maximumQuestions:3,

                doNotForceSection:true,

                omitSectionWhenNoSupportedQuestion:true,

                doNotForceDaily:true,

                preferRecurringClinicalPattern:true,

                preferProfileSpecificQuestion:true,

                preferPregnancySpecificQuestion:true,

                preferMedicationSafetyQuestionWhenMissed:true,

                avoidDuplicateMeaning:true

            }

        );


    /*==========================================================================
    FINAL COMPOSER
    ==========================================================================*/

    DATA.finalComposerRules=
        Object.assign(

            {},

            DATA.finalComposerRules ||
                {},

            {

                maximumNotice:1,

                maximumThread:1,

                maximumContrast:1,

                maximumPromiseReflections:1,

                maximumTomorrowFocus:1,

                maximumDoctorQuestions:3,

                preferProprietaryIntelligenceBeforeGenericScience:true,

                omitUnsupportedSections:true,

                silenceAllowed:true,

                neverInferLongitudinalCausation:true,

                neverFillSpaceForAppearance:true

            }

        );


    /*==========================================================================
    VALIDATION
    ==========================================================================*/

    DATA.validationRules=
        Object.assign(

            {},

            DATA.validationRules ||
                {},

            {

                validateStressSourceAgainstSupportedList:true,

                maximumNotice:1,

                maximumThread:1,

                maximumContrast:1,

                requireThreadMinimumStructuredDays:3,

                requireContrastMinimumComparableDays:4,

                requireContrastMinimumObservationsPerSide:2,

                rejectLongitudinalCausation:true

            }

        );


    /*==========================================================================
    ARCHIVE
    ==========================================================================*/

    DATA.archiveRules=
        Object.assign(

            {},

            DATA.archiveRules ||
                {},

            {

                storageKey:
                    "trestle_w007_insights",

                maximumInsights:
                    7,

                storePdfBinary:
                    false,

                storeStructuredInsight:
                    true,

                storeIntelligenceSnapshot:
                    true,

                longitudinalAnalysisLocation:
                    "localStorage",

                backendStorageAllowed:
                    false,

                sortNewestFirst:
                    true,

                cleanupOnLoad:
                    true,

                cleanupOnSave:
                    true,

                removeOldestWhenLimitExceeded:
                    true

            }

        );


    /*==========================================================================
    PDF
    ==========================================================================*/

    DATA.pdfRules=
        Object.assign(

            {},

            DATA.pdfRules ||
                {},

            {

                enabled:true,

                preferredPageSize:
                    "A4",

                preferredPageCount:
                    1,

                allowTwoPagesWhenNeeded:
                    true,

                useSameInsightObjectAsReader:
                    true,

                includeNotice:
                    true,

                includeThreadWhenAvailable:
                    true,

                includeContrastWhenAvailable:
                    true,

                includePromiseWhenAvailable:
                    true,

                includeSources:
                    true,

                includeDisclaimer:
                    true,

                includeDoctorQuestionsWhenAvailable:
                    true,

                includeInteractiveControls:
                    false,

                storePdfInLocalStorage:
                    false

            }

        );


    /*==========================================================================
    METADATA / PRIVACY
    ==========================================================================*/

    DATA.metadata=
        Object.assign(

            {},

            DATA.metadata ||
                {},

            {

                module:
                    "W007",

                name:
                    "TRESTLE Insight",

                intelligenceVersion:
                    "2.0",

                architecture:
                    "LOCAL_BROWSER_RULE_ENGINE",

                backendRequired:
                    false,

                gasRequired:
                    false,

                aiRequired:
                    false,

                personalDailyDataUploadRequired:
                    false,

                insightArchiveLocation:
                    "localStorage",

                longitudinalAnalysisLocation:
                    "localStorage",

                maximumArchivedInsights:
                    7

            }

        );


    console.info(
        "TRESTLE W007 Insight Data v2 rules active"
    );

})();